(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-screen-carousel-v1"] && !Shopify.designMode) return;
  try {
    
  function setCarouselSlideIndex(carousel, slideIndex = 1, dir = 0, goToTriggerRef = 'skip') {
    var slideItem = carousel.querySelector('[data-carousel-item="'+String(slideIndex)+'"]');
    
    if (slideItem) {
      Array.from(carousel.querySelectorAll('.app-screen-carousel__control-page')).forEach(function (pager) {
        pager.innerText = String(slideIndex).padStart(2, '0');
      });
      carousel.setAttribute('data-carousel-current', String(slideIndex));
    }
    var allSlides = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    allSlides.forEach(function (slide) {
      var slideIdx = slide.getAttribute('data-carousel-item');
      var isActive = slideIdx === String(slideIndex);
      var imagery = slide.querySelector('.app-screen-carousel__imagery');
      if (isActive) { imagery.style.setProperty('--C-item-offset-sign', dir); }
      else { imagery.style.removeProperty('--C-item-offset-sign'); }

      setTimeout(function() {
        var prefersReducedMotion = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        function focusSlideEl() {
          // Don't focus on page load!
          if (goToTriggerRef === 'skip') { return; }
        
          if (!goToTriggerRef) {
            slide.focus();
          } else {
            var goToTrigger = slide.querySelector('[data-carousel-goto="'+goToTriggerRef+'"]');
            if (goToTrigger) { goToTrigger.focus(); }
          }
        }
        
        if (isActive && !prefersReducedMotion) {
          slide.addEventListener('transitionend', function(e) {
            setTimeout(function() { focusSlideEl(); }, 10);
          }, { once: true });
        }
        
        slide.setAttribute('data-carousel-item-active', Boolean(isActive).toString());

        if (isActive && prefersReducedMotion) {
          focusSlideEl();
        }
      }, 50);
    });
  }

  function getGoToIndex(carousel, goToKey) {
    var current = parseInt(carousel.getAttribute('data-carousel-current'), 10);
    var max = parseInt(carousel.getAttribute('data-carousel-max'), 10);
    var goToDelta = goToKey === 'prev' ? -1 : 1;
    var goToIndex = current + goToDelta;
    if (goToIndex > max) { goToIndex = 1; }
    else if (goToIndex < 1) { goToIndex = max; }
    return { index: goToIndex, delta: goToDelta };
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    Array.from(document.querySelectorAll('.app-screen-carousel')).forEach(function(c) {
      c.setAttribute('data-is-interactive', 'true');
      setCarouselSlideIndex(c, 1, 0, 'skip');
    });
  });

  document.addEventListener('click', function(e) {
    var carouselButton = e.target.closest('.app-screen-carousel__control-button');
    if (!carouselButton) { return; }
    var carousel = carouselButton.closest('.app-screen-carousel');
    var goToKey = carouselButton.getAttribute('data-carousel-goto');
    var goToIndexAndDelta = getGoToIndex(carousel, goToKey);
    var goToIndex = goToIndexAndDelta.index;
    var goToDelta = goToIndexAndDelta.delta;
    
    setCarouselSlideIndex(carousel, goToIndex, goToDelta, goToKey);
  });

  document.addEventListener('muse:swipe', function (e) {
    var carousel = e.target.closest('.app-screen-carousel');
    if (!carousel) { return; }
    var currentIndex = parseInt(carousel.getAttribute('data-carousel-current'), 10);
    var swipeDirection = e.detail.swipeDirection.x;
    var goToKey = (swipeDirection === 'left') ?  'next' : 'prev';
    var goToIndexAndDelta = getGoToIndex(carousel, goToKey);
    var goToIndex = goToIndexAndDelta.index;
    var goToDelta = goToIndexAndDelta.delta;
    
    setCarouselSlideIndex(carousel, goToIndex, goToDelta, null);
  });

  Array.from(document.querySelectorAll('.app-screen-carousel__controls-wrapper[aria-hidden="true"] :is(button, a, input)')).forEach(function (interactiveElement) {
    interactiveElement.setAttribute('aria-hidden', 'true');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-screen-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  function setCarouselSlideIndex(carousel, slideIndex = 1, dir = 0, goToTriggerRef = 'skip') {
    var slideItem = carousel.querySelector('[data-carousel-item="'+String(slideIndex)+'"]');
    
    if (slideItem) {
      var initialAccent = slideItem.style.getPropertyValue('--C-accent-color');
      carousel.style.setProperty('--C-accent-color', initialAccent);
      Array.from(carousel.querySelectorAll('.app-screen-carousel__control-page')).forEach(function (pager) {
        pager.innerText = String(slideIndex).padStart(2, '0');
      });
      carousel.setAttribute('data-carousel-current', String(slideIndex));
    }
    var allSlides = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    allSlides.forEach(function (slide) {
      var slideIdx = slide.getAttribute('data-carousel-item');
      var isActive = slideIdx === String(slideIndex);
      var imagery = slide.querySelector('.app-screen-carousel__imagery');
      if (isActive) { imagery.style.setProperty('--C-item-offset-sign', dir); }
      else { imagery.style.removeProperty('--C-item-offset-sign'); }

      setTimeout(function() {
        var prefersReducedMotion = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        function focusSlideEl() {
          // Don't focus on page load!
          if (goToTriggerRef === 'skip') { return; }
        
          if (!goToTriggerRef) {
            slide.focus();
          } else {
            var goToTrigger = slide.querySelector('[data-carousel-goto="'+goToTriggerRef+'"]');
            if (goToTrigger) { goToTrigger.focus(); }
          }
        }
        
        if (isActive && !prefersReducedMotion) {
          slide.addEventListener('transitionend', function(e) {
            setTimeout(function() { focusSlideEl(); }, 10);
          }, { once: true });
        }
        
        slide.setAttribute('data-carousel-item-active', Boolean(isActive).toString());

        if (isActive && prefersReducedMotion) {
          focusSlideEl();
        }
      }, 50);
    });
  }

  function getGoToIndex(carousel, goToKey) {
    var current = parseInt(carousel.getAttribute('data-carousel-current'), 10);
    var max = parseInt(carousel.getAttribute('data-carousel-max'), 10);
    var goToDelta = goToKey === 'prev' ? -1 : 1;
    var goToIndex = current + goToDelta;
    if (goToIndex > max) { goToIndex = 1; }
    else if (goToIndex < 1) { goToIndex = max; }
    return { index: goToIndex, delta: goToDelta };
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    Array.from(document.querySelectorAll('.app-screen-carousel')).forEach(function(c) {
      c.setAttribute('data-is-interactive', 'true');
      setCarouselSlideIndex(c, 1, 0, 'skip');
    });
  });

  document.addEventListener('click', function(e) {
    var carouselButton = e.target.closest('.app-screen-carousel__control-button');
    if (!carouselButton) { return; }
    var carousel = carouselButton.closest('.app-screen-carousel');
    var goToKey = carouselButton.getAttribute('data-carousel-goto');
    var goToIndexAndDelta = getGoToIndex(carousel, goToKey);
    var goToIndex = goToIndexAndDelta.index;
    var goToDelta = goToIndexAndDelta.delta;
    
    setCarouselSlideIndex(carousel, goToIndex, goToDelta, goToKey);
  });

  document.addEventListener('muse:swipe', function (e) {
    var carousel = e.target.closest('.app-screen-carousel');
    if (!carousel) { return; }
    var currentIndex = parseInt(carousel.getAttribute('data-carousel-current'), 10);
    var swipeDirection = e.detail.swipeDirection.x;
    var goToKey = (swipeDirection === 'left') ?  'next' : 'prev';
    var goToIndexAndDelta = getGoToIndex(carousel, goToKey);
    var goToIndex = goToIndexAndDelta.index;
    var goToDelta = goToIndexAndDelta.delta;
    
    setCarouselSlideIndex(carousel, goToIndex, goToDelta, null);
  });

  Array.from(document.querySelectorAll('.app-screen-carousel__controls-wrapper[aria-hidden="true"] :is(button, a, input)')).forEach(function (interactiveElement) {
    interactiveElement.setAttribute('aria-hidden', 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contained-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  function setCarouselSlideIndex(carousel, slideIndex = 1, dir = 0, goToTriggerRef = 'skip') {
    var slideItem = carousel.querySelector('[data-carousel-item="'+String(slideIndex)+'"]');
    
    if (slideItem) {
      var initialAccent = slideItem.style.getPropertyValue('--C-accent-color');
      carousel.style.setProperty('--C-accent-color', initialAccent);
      Array.from(carousel.querySelectorAll('.v2-contained-carousel__control-page')).forEach(function (pager) {
        pager.innerText = String(slideIndex).padStart(2, '0');
      });
      carousel.setAttribute('data-carousel-current', String(slideIndex));
    }
    var allSlides = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    allSlides.forEach(function (slide) {
      var slideIdx = slide.getAttribute('data-carousel-item');
      var isActive = slideIdx === String(slideIndex);
      if (isActive) { slide.style.setProperty('--C-item-offset-sign', dir); }
      else { slide.style.removeProperty('--C-item-offset-sign'); }

      setTimeout(function() {
        var prefersReducedMotion = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        function focusSlideEl() {
          // Don't focus on page load!
          if (goToTriggerRef === 'skip') { return; }
        
          if (!goToTriggerRef) {
            slide.focus();
          } else {
            var goToTrigger = slide.querySelector('[data-carousel-goto="'+goToTriggerRef+'"]');
            if (goToTrigger) { goToTrigger.focus(); }
          }
        }
        
        if (isActive && !prefersReducedMotion) {
          slide.addEventListener('transitionend', function(e) {
            setTimeout(function() { focusSlideEl(); }, 10);
          }, { once: true });
        }
        
        slide.setAttribute('data-carousel-item-active', Boolean(isActive).toString());

        if (isActive && prefersReducedMotion) {
          focusSlideEl();
        }
      }, 50);
    });
  }

  function getGoToIndex(carousel, goToKey) {
    var current = parseInt(carousel.getAttribute('data-carousel-current'), 10);
    var max = parseInt(carousel.getAttribute('data-carousel-max'), 10);
    var goToDelta = goToKey === 'prev' ? -1 : 1;
    var goToIndex = current + goToDelta;
    if (goToIndex > max) { goToIndex = 1; }
    else if (goToIndex < 1) { goToIndex = max; }
    return { index: goToIndex, delta: goToDelta };
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    Array.from(document.querySelectorAll('.v2-contained-carousel')).forEach(function(c) {
      c.setAttribute('data-is-interactive', 'true');
      setCarouselSlideIndex(c, 1, 0, 'skip');
    });
  });

  document.addEventListener('click', function(e) {
    var carouselButton = e.target.closest('.v2-contained-carousel__control-button');
    if (!carouselButton) { return; }
    var carousel = carouselButton.closest('.v2-contained-carousel');
    var goToKey = carouselButton.getAttribute('data-carousel-goto');
    var goToIndexAndDelta = getGoToIndex(carousel, goToKey);
    var goToIndex = goToIndexAndDelta.index;
    var goToDelta = goToIndexAndDelta.delta;
    
    setCarouselSlideIndex(carousel, goToIndex, goToDelta, goToKey);
  });

  document.addEventListener('muse:swipe', function (e) {
    var carousel = e.target.closest('.v2-contained-carousel');
    if (!carousel) { return; }
    var currentIndex = parseInt(carousel.getAttribute('data-carousel-current'), 10);
    var swipeDirection = e.detail.swipeDirection.x;
    var goToKey = (swipeDirection === 'left') ?  'next' : 'prev';
    var goToIndexAndDelta = getGoToIndex(carousel, goToKey);
    var goToIndex = goToIndexAndDelta.index;
    var goToDelta = goToIndexAndDelta.delta;
    
    setCarouselSlideIndex(carousel, goToIndex, goToDelta, null);
  });

  Array.from(document.querySelectorAll('.v2-contained-carousel__controls-wrapper[aria-hidden="true"] :is(button, a, input)')).forEach(function (interactiveElement) {
    interactiveElement.setAttribute('aria-hidden', 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer-banner"] && !Shopify.designMode) return;
  try {
    
    class CountdownTimer extends HTMLElement {
    constructor() {
        super();
    }

    init() {
        this.schemaTime = this.getAttribute('schema-time');
        this.timer = this.querySelector(".timer")
        this.countdown = new Date(this.schemaTime).getTime();
        this.second = 1000;
        this.minute = this.second * 60;
        this.hour = this.minute * 60;
        this.day = this.hour * 24;

        this.timerInterval = null;
        this.startTimer();

        setTimeout(() => this.timer.style.visibility = "visible", 1000)
    }

    padWithLeadingZero = (number) => {
        if (number < 10) {
            return '0' + number;
        } else {
            return number;
        }
    };

    isDateInPast(date) {
        const now = new Date();
        return date < now;
    }


    startTimer() {
        //Have quick check to see if Date input in the countdown class variable is in the past
        //Helper function

        const timerElem = this.timer

        this.timerInterval = setInterval(() => {
            const now = new Date().getTime();
            const distance = this.countdown - now;

            const dayCalc = Math.floor(distance / this.day);
            const hourCalc = Math.floor((distance % this.day) / this.hour);
            const minuteCalc = Math.floor((distance % this.hour) / this.minute);
            const secondCalc = Math.floor((distance % this.minute) / this.second);

            timerElem.querySelector('.js-timer-days').textContent = this.padWithLeadingZero(dayCalc);
            timerElem.querySelector('.js-timer-hours').textContent = this.padWithLeadingZero(hourCalc);
            timerElem.querySelector('.js-timer-minutes').textContent = this.padWithLeadingZero(minuteCalc);
            timerElem.querySelector('.js-timer-seconds').textContent = this.padWithLeadingZero(secondCalc);
        }, this.second);
    }

    disconnectedCallback() {
        clearInterval(this.timerInterval);
    }

    connectedCallback(){
        this.init();
        console.log("countdown timer was added to the page")
        
        const timerFlexContainer = window.document.querySelector(".timer-flex-container")
        const timerElem = this.timer

        const pastDate = this.isDateInPast(this.countdown)
        if(pastDate){
            timerFlexContainer.remove()
            this.remove()
        }
        window.setTimeout(() => {
            timerFlexContainer.classList.remove("hide-element")
        }, 2000);
    }
}


    customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expand-card-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var summary = e.target.closest('.v1-expand-card-carousel__summary');
    if (!summary) { return; }
    var details = summary.closest('.v1-expand-card-carousel__card');
    var carousel = details.closest('.v1-expand-card-carousel__cards');
    var content = details.querySelector('.v1-expand-card-carousel__content');
    
    // Attempting to close the only open card is prevented
    if (details.open) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    var detailsName = summary.getAttribute('name');
    var otherDetails = Array.from(document.querySelectorAll('details[name="'+detailsName+'"]'));
    otherDetails.forEach(function (d) {
      if (d !== details && d.open) {
        d.open = false;
        d.removeAttribute('open');
      }
    });

    // No animation requested
    var acceptAnimation = Boolean(window.matchMedia('(prefers-reduced-motion: no-preference)').matches);
    if (!acceptAnimation) { return; }
    
    // Since mobile is column and desktop is row, we can infer the current screen size with flex-direction
    var isLikelyDesktop = window.getComputedStyle(carousel).flexDirection === 'row';
    if (isLikelyDesktop && !!summary.animate) {
      // Before click
      var transitionData = window.getComputedStyle(details);
      var transitionDuration = (parseFloat(transitionData.transitionDuration) || 0.3) * 1000; // getComputedValue returns a result in seconds
      var transitionEasing = transitionData.transitionTimingFunction || 'ease-in-out';
      var startingStyles = window.getComputedStyle(summary);
      var startingHeight = startingStyles.height;
      var startingWidth = startingStyles.width;
      var contentWidthPx = content.clientWidth || parseFloat(startingWidth);
      var contentWidth = contentWidthPx + 'px';
      var contentWidth2x = (contentWidthPx * 2) + 'px';
      content.style.width = contentWidth2x; // Set its initial width to be doubled so the number of lines remains consistent
      requestAnimationFrame(function() {
        // After click
        var targetHeight = window.getComputedStyle(summary).height;
        var contentHeight = window.getComputedStyle(content).height;

        // After repaint

        // Common animation
        var timing = {
          duration: transitionDuration,
          iterations: 1,
          easing: transitionEasing,
          delay: 20,
          fill: 'backwards',
        };
        
        // Animation for the summary
        var keyframesSummary = [
          { height: startingHeight },
          { height: targetHeight },
        ];
        
        // Animation for the content
        var keyframesContent = [
          { width: contentWidth, height: '0px' },
          { width: contentWidth2x, height: contentHeight },
        ];
        var debug = window.getComputedStyle(content);
        console.log({ currContentW: debug.width, currContentH: debug.height });
        console.log({contentHeight, contentWidthPx, contentWidth, contentWidth2x})

        // Trigger both animations nearly-simultaneously
        var animSummary = summary.animate(keyframesSummary, timing);
        var animContent = content.animate(keyframesContent, timing);
        var animPromiser = Promise.resolve(animContent.finished);
        animPromiser.then(function() {
          content.style.width = '';
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expander-group-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
   Array.from(document.querySelectorAll('.v2-expander-group__wrapper details')).forEach(function (details) {
     details.addEventListener('toggle', function (e) {
        let event = new CustomEvent('muse:details-toggle', {
          bubbles: true,
          detail: {
            target: e.target,
            oldState: e.oldState,
            newState: e.newState,
          }
        });
        details.dispatchEvent(event);
      })
   }) 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flipcard-carousel-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  const TabSlider = {
    init() {
      this.sliders = document.querySelectorAll('#flip-tab .v2-tab-slider');
      if (!this.sliders.length) return;
      this.sliders.forEach(slider => this.initSlider(slider));
    },

    initSlider(slider) {
      const slidesWrapper = slider.querySelector('.v1-flipcard-carousel__cards');
      if (!slidesWrapper) return;

      // Let the browser handle all scrolling natively
      slidesWrapper.style.overflowX = 'auto';
      slidesWrapper.style.scrollSnapType = 'x mandatory';
      slidesWrapper.style.webkitOverflowScrolling = 'touch';

      // Each card snaps into place
      slider.querySelectorAll('.v1-flipcard-carousel__card[data-slide-index]').forEach(card => {
        card.style.scrollSnapAlign = 'center';
        card.style.flexShrink = '0';
      });

      // Set first tab active on load
      const firstSlide = slider.querySelector('.v1-flipcard-carousel__cards [data-slide-index="1"]');
      const firstGroup = firstSlide ? firstSlide.getAttribute('data-tab-group') : null;
      this.updateTabs(slider, firstGroup, 1);

      // Watch cards with IntersectionObserver
      this.observeCards(slider, slidesWrapper);

      // Tab clicks scroll to first card of that group
      slider.querySelectorAll('[data-tab-index]').forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const targetIndex = parseInt(tab.getAttribute('data-tab-index'), 10);
          const targetSlide = slider.querySelector(
            `.v1-flipcard-carousel__cards [data-slide-index="${targetIndex}"]`
          );
          if (targetSlide) {
            targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    },

    observeCards(slider, slidesWrapper) {
      const cards = slider.querySelectorAll('.v1-flipcard-carousel__cards [data-slide-index]');

      const observer = new IntersectionObserver((entries) => {
        // Find the most visible card
        let mostVisible = null;
        let highestRatio = 0;

        entries.forEach(entry => {
          if (entry.intersectionRatio > highestRatio) {
            highestRatio = entry.intersectionRatio;
            mostVisible = entry.target;
          }
        });

        if (mostVisible) {
          const group = mostVisible.getAttribute('data-tab-group');
          const index = parseInt(mostVisible.getAttribute('data-slide-index'), 10);
          this.updateTabs(slider, group, index);
        }
      }, {
        root: slidesWrapper,
        threshold: [0.5, 0.75, 1.0] // fire when card is 50%, 75%, or fully visible
      });

      cards.forEach(card => observer.observe(card));
    },

    updateTabs(slider, activeGroup, activeIndex) {
      // Update tab active states
      slider.querySelectorAll('[data-tab-index]').forEach(tab => {
        const tabHref = tab.getAttribute('data-tab-href');
        const isActive = activeGroup
          ? tabHref === activeGroup
          : tab.getAttribute('data-tab-index') === String(activeIndex);
        tab.setAttribute('aria-pressed', isActive.toString());
      });

      // Update slide active states
      slider.querySelectorAll('.v1-flipcard-carousel__cards [data-slide-index]').forEach(slide => {
        const slideGroup = slide.getAttribute('data-tab-group');
        const slideIndex = parseInt(slide.getAttribute('data-slide-index'), 10);
        const isActive = activeGroup
          ? slideGroup === activeGroup
          : slideIndex === activeIndex;
        slide.setAttribute('data-slide-active', isActive.toString());
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => TabSlider.init());
  } else {
    TabSlider.init();
  }
})();
// (function() {
//   'use strict';
//   const TabSlider = {
//     init() {
//       this.sliders = document.querySelectorAll('#flip-tab .v2-tab-slider');
//       if (!this.sliders.length) return;

//       this.sliders.forEach(slider => this.initSlider(slider));
//       this.attachEventListeners();
//     },

//     initSlider(slider) {
//       const firstTab = slider.querySelector('#flip-tab [data-tab-index="1"]');
//       const firstSlide = slider.querySelector('#flip-tab [data-slide-index="1"]');
      
//       if (firstTab) firstTab.setAttribute('aria-pressed', 'true');
//       if (firstSlide) firstSlide.setAttribute('data-slide-active', 'true');
//     },

//     setActiveTab(slider, targetIndex) {
//       const maxSlides = parseInt(slider.getAttribute('data-slide-max'), 10);
//       const slideIndex = Math.max(1, Math.min(targetIndex, maxSlides));
      
//       // Get the tab group of the target slide
//       const targetSlide = slider.querySelector(`[data-slide-index="${slideIndex}"]`);
//       const targetGroup = targetSlide ? targetSlide.getAttribute('data-tab-group') : null;

//       // Find the last slide in the group for scrolling
//       let lastSlideInGroup = slideIndex;
//       if (targetGroup) {
//         const allSlidesInGroup = slider.querySelectorAll(`[data-tab-group="${targetGroup}"]`);
//         if (allSlidesInGroup.length > 0) {
//           const lastSlide = allSlidesInGroup[allSlidesInGroup.length - 1];
//           lastSlideInGroup = parseInt(lastSlide.getAttribute('data-slide-index'), 10);
//         }
//       }

//       // Update all tabs and slides
//       for (let i = 1; i <= maxSlides; i++) {
//         const tab = slider.querySelector(`[data-tab-index="${i}"]`);
//         const slide = slider.querySelector(`[data-slide-index="${i}"]`);
//         const slideGroup = slide ? slide.getAttribute('data-tab-group') : null;
        
//         // A slide is active if it's the target OR if it shares the same group
//         const isActive = (i === slideIndex) || (targetGroup && slideGroup === targetGroup);

//         if (tab) tab.setAttribute('aria-pressed', (i === slideIndex).toString());
//         if (slide) slide.setAttribute('data-slide-active', isActive.toString());
//       }

//       slider.setAttribute('data-slide-current', slideIndex);
      
//       // Scroll to the last slide in the group
//       this.scrollToSlide(slider, lastSlideInGroup);
//     },

//     scrollToSlide(slider, slideIndex) {
//       const slide = slider.querySelector(`#flip-tab [data-slide-index="${slideIndex}"]`);
//       const slidesWrapper = slider.querySelector('#flip-tab .v1-flipcard-carousel__cards-container');
      
//       if (!slide || !slidesWrapper) return;

//       // If it's the first slide, scroll to show it with 16px padding from left
//       if (slideIndex === 1) {
//         const slideOffset = slide.offsetLeft;
//         slidesWrapper.scrollTo({
//           left: slideOffset - 16,
//           behavior: 'smooth'
//         });
//         return;
//       }

//       // Check if this slide is part of a group
//       const slideGroup = slide.getAttribute('data-tab-group');
      
//       if (slideGroup) {
//         // Get all slides in the same group
//         const allSlidesInGroup = slider.querySelectorAll(`[data-tab-group="${slideGroup}"]`);
        
//         if (allSlidesInGroup.length > 1) {
//           // Get the second-to-last card and last card
//           const secondLastSlide = allSlidesInGroup[allSlidesInGroup.length - 2];
//           const lastSlide = allSlidesInGroup[allSlidesInGroup.length - 1];
          
//           // Calculate position to show 50% of each card
//           const secondLastOffset = secondLastSlide.offsetLeft;
//           const secondLastWidth = secondLastSlide.offsetWidth;
          
//           // Position to center between the two cards (showing 50% of each)
//           const scrollPosition = secondLastOffset + (secondLastWidth / 2);
          
//           slidesWrapper.scrollTo({
//             left: scrollPosition,
//             behavior: 'smooth'
//           });
//           return;
//         }
//       }
      
//       // Default behavior for single cards
//       const slideOffset = slide.offsetLeft;
//       const slideWidth = slide.offsetWidth;
//       const wrapperWidth = slidesWrapper.offsetWidth;
//       const scrollPosition = slideOffset - (wrapperWidth / 2) + (slideWidth / 2);

//       slidesWrapper.scrollTo({
//         left: scrollPosition,
//         behavior: 'smooth'
//       });
//     },

//     scrollToTab(tabHref) {
//       const targetElement = document.getElementById(tabHref);
//       if (!targetElement) return;

//       const slider = targetElement.closest('.v2-tab-slider');
//       if (!slider) return;

//       const slideIndex = parseInt(targetElement.getAttribute('data-slide-index'), 10);
//       this.setActiveTab(slider, slideIndex);
//     },

//     handleTabClick(e) {
//       const trigger = e.target.closest('[data-tab-index]');
//       if (!trigger) return;

//       e.preventDefault();
//       const slider = trigger.closest('.v2-tab-slider');
//       const targetIndex = parseInt(trigger.getAttribute('data-tab-index'), 10);
//       const tabHref = trigger.getAttribute('data-tab-href');

//       this.setActiveTab(slider, targetIndex);
//     },

//     handleSwipe(e) {
//       const slider = e.target.closest('.v2-tab-slider');
//       if (!slider) return;

//       const currentIndex = parseInt(slider.getAttribute('data-slide-current'), 10);
//       const maxSlides = parseInt(slider.getAttribute('data-slide-max'), 10);
//       const swipeDirection = e.detail.swipeDirection.x;

//       let newIndex = currentIndex;
//       if (swipeDirection === 'left' && currentIndex < maxSlides) {
//         newIndex = currentIndex + 1;
//       } else if (swipeDirection === 'right' && currentIndex > 1) {
//         newIndex = currentIndex - 1;
//       }

//       if (newIndex !== currentIndex) {
//         this.setActiveTab(slider, newIndex);
//       }
//     },

//     attachEventListeners() {
//       document.addEventListener('click', (e) => this.handleTabClick(e));
//       document.addEventListener('muse:swipe', (e) => this.handleSwipe(e));
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => TabSlider.init());
//   } else {
//     TabSlider.init();
//   }
// })();

// (function() {
//   'use strict';
//   const TabSlider = {
//     init() {
//       this.sliders = document.querySelectorAll('#flip-tab .v2-tab-slider');
//       if (!this.sliders.length) return;

//       this.sliders.forEach(slider => this.initSlider(slider));
//       this.attachEventListeners();
//     },

//     initSlider(slider) {
//       const firstTab = slider.querySelector('#flip-tab [data-tab-index="1"]');
//       const firstSlide = slider.querySelector('#flip-tab [data-slide-index="1"]');
      
//       if (firstTab) firstTab.setAttribute('aria-pressed', 'true');
//       if (firstSlide) firstSlide.setAttribute('data-slide-active', 'true');
//     },

//     setActiveTab(slider, targetIndex) {
//       const maxSlides = parseInt(slider.getAttribute('data-slide-max'), 10);
//       const slideIndex = Math.max(1, Math.min(targetIndex, maxSlides));
      
//       // Get the tab group of the target slide
//       const targetSlide = slider.querySelector(`[data-slide-index="${slideIndex}"]`);
//       const targetGroup = targetSlide ? targetSlide.getAttribute('data-tab-group') : null;

//       // Find the last slide in the group for scrolling
//       let lastSlideInGroup = slideIndex;
//       if (targetGroup) {
//         const allSlidesInGroup = slider.querySelectorAll(`[data-tab-group="${targetGroup}"]`);
//         if (allSlidesInGroup.length > 0) {
//           const lastSlide = allSlidesInGroup[allSlidesInGroup.length - 1];
//           lastSlideInGroup = parseInt(lastSlide.getAttribute('data-slide-index'), 10);
//         }
//       }

//       // Update all tabs and slides
//       for (let i = 1; i <= maxSlides; i++) {
//         const tab = slider.querySelector(`[data-tab-index="${i}"]`);
//         const slide = slider.querySelector(`[data-slide-index="${i}"]`);
//         const slideGroup = slide ? slide.getAttribute('data-tab-group') : null;
        
//         // A slide is active if it's the target OR if it shares the same group
//         const isActive = (i === slideIndex) || (targetGroup && slideGroup === targetGroup);

//         if (tab) tab.setAttribute('aria-pressed', (i === slideIndex).toString());
//         if (slide) slide.setAttribute('data-slide-active', isActive.toString());
//       }

//       slider.setAttribute('data-slide-current', slideIndex);
      
//       // Scroll to the last slide in the group
//       this.scrollToSlide(slider, lastSlideInGroup);
//     },

//     scrollToSlide(slider, slideIndex) {
//       const slide = slider.querySelector(`#flip-tab [data-slide-index="${slideIndex}"]`);
//       const slidesWrapper = slider.querySelector('#flip-tab .v2-tab-slider__slides-wrapper');
      
//       if (!slide || !slidesWrapper) return;

//       // Check if this slide is part of a group
//       const slideGroup = slide.getAttribute('data-tab-group');
      
//       if (slideGroup) {
//         // Get all slides in the same group
//         const allSlidesInGroup = slider.querySelectorAll(`[data-tab-group="${slideGroup}"]`);
        
//         if (allSlidesInGroup.length > 1) {
//           // Get the second-to-last card and last card
//           const secondLastSlide = allSlidesInGroup[allSlidesInGroup.length - 2];
//           const lastSlide = allSlidesInGroup[allSlidesInGroup.length - 1];
          
//           // Calculate position to show 50% of each card
//           const secondLastOffset = secondLastSlide.offsetLeft;
//           const secondLastWidth = secondLastSlide.offsetWidth;
          
//           // Position to center between the two cards (showing 50% of each)
//           const scrollPosition = secondLastOffset + (secondLastWidth / 2);
          
//           slidesWrapper.scrollTo({
//             left: scrollPosition,
//             behavior: 'smooth'
//           });
//           return;
//         }
//       }
      
//       // Default behavior for single cards
//       const slideOffset = slide.offsetLeft;
//       const slideWidth = slide.offsetWidth;
//       const wrapperWidth = slidesWrapper.offsetWidth;
//       const scrollPosition = slideOffset - (wrapperWidth / 2) + (slideWidth / 2);

//       slidesWrapper.scrollTo({
//         left: scrollPosition,
//         behavior: 'smooth'
//       });
//     },

//     scrollToTab(tabHref) {
//       const targetElement = document.getElementById(tabHref);
//       if (!targetElement) return;

//       const slider = targetElement.closest('.v2-tab-slider');
//       if (!slider) return;

//       const slideIndex = parseInt(targetElement.getAttribute('data-slide-index'), 10);
//       this.setActiveTab(slider, slideIndex);
//     },

//     handleTabClick(e) {
//       const trigger = e.target.closest('[data-tab-index]');
//       if (!trigger) return;

//       e.preventDefault();
//       const slider = trigger.closest('.v2-tab-slider');
//       const targetIndex = parseInt(trigger.getAttribute('data-tab-index'), 10);
//       const tabHref = trigger.getAttribute('data-tab-href');

//       this.setActiveTab(slider, targetIndex);
//     },

//     handleSwipe(e) {
//       const slider = e.target.closest('.v2-tab-slider');
//       if (!slider) return;

//       const currentIndex = parseInt(slider.getAttribute('data-slide-current'), 10);
//       const maxSlides = parseInt(slider.getAttribute('data-slide-max'), 10);
//       const swipeDirection = e.detail.swipeDirection.x;

//       let newIndex = currentIndex;
//       if (swipeDirection === 'left' && currentIndex < maxSlides) {
//         newIndex = currentIndex + 1;
//       } else if (swipeDirection === 'right' && currentIndex > 1) {
//         newIndex = currentIndex - 1;
//       }

//       if (newIndex !== currentIndex) {
//         this.setActiveTab(slider, newIndex);
//       }
//     },

//     attachEventListeners() {
//       document.addEventListener('click', (e) => this.handleTabClick(e));
//       document.addEventListener('muse:swipe', (e) => this.handleSwipe(e));
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => TabSlider.init());
//   } else {
//     TabSlider.init();
//   }
// })();


// (function() {
//   'use strict';
//   const TabSlider = {
//     init() {
//       this.sliders = document.querySelectorAll('#flip-tab .v2-tab-slider');
//       if (!this.sliders.length) return;

//       this.sliders.forEach(slider => this.initSlider(slider));
//       this.attachEventListeners();
//     },

//     initSlider(slider) {
//       const firstTab = slider.querySelector('#flip-tab [data-tab-index="1"]');
//       const firstSlide = slider.querySelector('#flip-tab [data-slide-index="1"]');
      
//       if (firstTab) firstTab.setAttribute('aria-pressed', 'true');
//       if (firstSlide) firstSlide.setAttribute('data-slide-active', 'true');
//     },

//     setActiveTab(slider, targetIndex) {
//       const maxSlides = parseInt(slider.getAttribute('data-slide-max'), 10);
//       const slideIndex = Math.max(1, Math.min(targetIndex, maxSlides));
      
//       // Get the tab group of the target slide
//       const targetSlide = slider.querySelector(`[data-slide-index="${slideIndex}"]`);
//       const targetGroup = targetSlide ? targetSlide.getAttribute('data-tab-group') : null;

//       // Find the last slide in the group for scrolling
//       let lastSlideInGroup = slideIndex;
//       if (targetGroup) {
//         const allSlidesInGroup = slider.querySelectorAll(`[data-tab-group="${targetGroup}"]`);
//         if (allSlidesInGroup.length > 0) {
//           const lastSlide = allSlidesInGroup[allSlidesInGroup.length - 1];
//           lastSlideInGroup = parseInt(lastSlide.getAttribute('data-slide-index'), 10);
//         }
//       }

//       // Update all tabs and slides
//       for (let i = 1; i <= maxSlides; i++) {
//         const tab = slider.querySelector(`[data-tab-index="${i}"]`);
//         const slide = slider.querySelector(`[data-slide-index="${i}"]`);
//         const slideGroup = slide ? slide.getAttribute('data-tab-group') : null;
        
//         // A slide is active if it's the target OR if it shares the same group
//         const isActive = (i === slideIndex) || (targetGroup && slideGroup === targetGroup);

//         if (tab) tab.setAttribute('aria-pressed', (i === slideIndex).toString());
//         if (slide) slide.setAttribute('data-slide-active', isActive.toString());
//       }

//       slider.setAttribute('data-slide-current', slideIndex);
      
//       // Scroll to the last slide in the group
//       this.scrollToSlide(slider, lastSlideInGroup);
//     },

//     scrollToSlide(slider, slideIndex) {
//       const slide = slider.querySelector(`#flip-tab [data-slide-index="${slideIndex}"]`);
//       const slidesWrapper = slider.querySelector('#flip-tab .v2-tab-slider__slides-wrapper');
      
//       if (!slide || !slidesWrapper) return;

//       const slideOffset = slide.offsetLeft;
//       const slideWidth = slide.offsetWidth;
//       const wrapperWidth = slidesWrapper.offsetWidth;
//       const scrollPosition = slideOffset - (wrapperWidth / 2) + (slideWidth / 2);

//       slidesWrapper.scrollTo({
//         left: scrollPosition,
//         behavior: 'smooth'
//       });
//     },

//     scrollToTab(tabHref) {
//       const targetElement = document.getElementById(tabHref);
//       if (!targetElement) return;

//       const slider = targetElement.closest('.v2-tab-slider');
//       if (!slider) return;

//       const slideIndex = parseInt(targetElement.getAttribute('data-slide-index'), 10);
//       this.setActiveTab(slider, slideIndex);
//     },

//     handleTabClick(e) {
//       const trigger = e.target.closest('[data-tab-index]');
//       if (!trigger) return;

//       e.preventDefault();
//       const slider = trigger.closest('.v2-tab-slider');
//       const targetIndex = parseInt(trigger.getAttribute('data-tab-index'), 10);
//       const tabHref = trigger.getAttribute('data-tab-href');

//       this.setActiveTab(slider, targetIndex);
//     },

//     handleSwipe(e) {
//       const slider = e.target.closest('.v2-tab-slider');
//       if (!slider) return;

//       const currentIndex = parseInt(slider.getAttribute('data-slide-current'), 10);
//       const maxSlides = parseInt(slider.getAttribute('data-slide-max'), 10);
//       const swipeDirection = e.detail.swipeDirection.x;

//       let newIndex = currentIndex;
//       if (swipeDirection === 'left' && currentIndex < maxSlides) {
//         newIndex = currentIndex + 1;
//       } else if (swipeDirection === 'right' && currentIndex > 1) {
//         newIndex = currentIndex - 1;
//       }

//       if (newIndex !== currentIndex) {
//         this.setActiveTab(slider, newIndex);
//       }
//     },


//     attachEventListeners() {
//       document.addEventListener('click', (e) => this.handleTabClick(e));
//       document.addEventListener('muse:swipe', (e) => this.handleSwipe(e));
      
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => TabSlider.init());
//   } else {
//     TabSlider.init();
//   }
// })();





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-header-v1"] && !Shopify.designMode) return;
  try {
    
// Whenever [data-floating-header-logo] intersects with .shopify-section, check the background color and flip the nav if needed
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.v1-floating-header');
  const toggle = header.querySelector('.v1-floating-header__menu-toggle[hidden]');
  toggle.hidden = false;

  function setMenuState(menuId, isOpen) {
    var menu = document.getElementById(menuId);
    if (isOpen) {
      menu.removeAttribute('inert');
      menu.classList.add('is-open');
    } else {
      menu.setAttribute('inert', '');
      menu.classList.remove('is-open');
    }
  }

  document.addEventListener('click', function(e) {
    var target;
    if ((target = e.target.closest('[data-menu-action][data-menu-target]'))) {
      var targetAction = target.getAttribute('data-menu-action');
      var targetMenuId = target.getAttribute('data-menu-target');
      setMenuState(targetMenuId, targetAction === 'open');
    } else if ((target = e.target.closest('.v1-floating-header__menu-link'))) {
      var targetMenuId = target.closest('.v1-floating-header__menu-container').getAttribute('id');
      setMenuState(targetMenuId, false);
    }
  });
  
  const observer = new IntersectionObserver((entries, observer) => {
    const entryClosestToTop = Array.from(entries).find((entry) => entry.intersectionRect.bottom >= header.clientHeight && entry.intersectionRect.top <= 0);
    if (!entryClosestToTop) { return; }
    const entry = entryClosestToTop.target;
    const entryScheme = entry.getAttribute('data-component-scheme');
    const newNavbarColor = entryScheme === 'dark' ? 'white' : 'black';
    header.style.setProperty('--C-color', newNavbarColor);
  }, { threshold: 1.0 });
  const schemeSections = Array.from(document.querySelectorAll('[data-component-scheme]'));
  // schemeSections.forEach((section) => observer.observe(section));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-header-v2"] && !Shopify.designMode) return;
  try {
    
// Whenever [data-floating-header-logo] intersects with .shopify-section, check the background color and flip the nav if needed
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.v2-floating-header');
  // Unhide JS-only elements
  Array.from(header.querySelectorAll('[data-js-unhide][hidden]')).forEach(function(el) {
    el.hidden = false;
  });
  
  // Convert standard links into interactive buttons
  Array.from(header.querySelectorAll('a[data-anchor-to-button]')).forEach(function(a) {
    var button = document.createElement('button');
    button.type = 'button';

    // Copy all attributes...
    (Array.from(a.attributes) || []).forEach(function(attr) {
      // ...except the href and data-attribute markign the node for conversion
      if (attr.nodeName !== 'data-anchor-to-button' && attr.nodeName !== 'href') {
        button.setAttribute(attr.nodeName, attr.nodeValue);
      }
    });

    // Move all child nodes from the a into the button
    (Array.from(a.childNodes) || []).forEach(function(child) {
      button.append(child);
    });

    // Place the button right after the original a
    a.insertAdjacentElement('afterend', button);

    // Delete the original a
    a.parentElement.removeChild(a);
  });

  function setMenuState(menuId, isOpen, doFocus = true) {
    var menu = document.getElementById(menuId);
    if (isOpen) {
      menu.removeAttribute('inert');
      menu.classList.add('is-open');
      if (doFocus) {
        document.querySelector('[data-menu-action="close"]').focus();
      }
    } else {
      menu.setAttribute('inert', '');
      menu.classList.remove('is-open');
      if (doFocus) {
        document.querySelector('[data-menu-action="open"]').focus();
      }
    }
  }

  function setSearchState(searchForm, isOpen = null, onCloseFocus = false) {
    var oldOpenState = !searchForm.hidden;
    var wasClosed = oldOpenState === false;
    var newOpenState = isOpen === null ? !oldOpenState : Boolean(isOpen);
    var searchInput = searchForm.querySelector('input[name="q"]');
    searchForm.hidden = !newOpenState;
    
    if (newOpenState === true) {
      if (searchInput) {
        searchInput.focus();
      }
    } else if (newOpenState === false) {
      if (onCloseFocus) {
        onCloseFocus.focus();
      }
    }
  }

  document.addEventListener('click', function(e) {
    var target;
    if ((target = e.target.closest('[data-menu-action][data-menu-target]'))) {
      var targetAction = target.getAttribute('data-menu-action');
      var targetMenuId = target.getAttribute('data-menu-target');
      setMenuState(targetMenuId, targetAction === 'open');
    } else if ((target = e.target.closest('.v2-floating-header__menu-link'))) {
      var targetMenuId = target.closest('.v2-floating-header__menu-container').getAttribute('id');
      setMenuState(targetMenuId, false);
    } else if ((target = e.target.closest('[data-navbar-target="search"]'))) {
      var searchForm = target.closest('.v2-floating-header__container').querySelector('[data-navbar-action="search"]');
      setSearchState(searchForm);
    } else if ((target = e.target.closest('[data-open-sidecart]'))) {
      var sidecart = target.closest('.v2-floating-header__wrapper').querySelector('.sidecart');
      sidecart.setAttribute('data-show', 'true');
    } else if ((target = e.target.closest('[data-close-sidecart]'))) {
      var sidecart = target.closest('.v2-floating-header__wrapper').querySelector('.sidecart');
      sidecart.setAttribute('data-show', 'false');
    } else if ((target = e.target.closest('[data-checkout]'))) {
      function getCookie(h) {
          var match = document.cookie.match(new RegExp("(?:^|; )" + h.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
          return match ? match[1] : false;
      }

      var topLevelDomain = 'choosemuse.com';
      var subdomain = getCookie("_muse_store");
      window.location.href = `https://${subdomain && subdomain !== "us" ? subdomain+"." : ""}${topLevelDomain}/checkout`;
    }
    //! after this series of conditions, `target` can be null or a matching element, do not rely on its value

    // Force close the search if clicking outside
    if (e.target && !e.target.closest('[data-navbar-target="search"], [data-navbar-action="search"]')) {
      var formToClose = document.querySelector('[data-navbar-action="search"]');
      if (formToClose) {
        setSearchState(formToClose, false);
      }
    }
  });

  document.addEventListener('keyup', function(e) {
    var target;
    if (e.key === 'Escape') {
      if ((target = e.target.closest('[data-navbar-action="search"]'))) {
        var wrapper = target.closest('.v2-floating-header__wrapper');
        var trigger = wrapper.querySelector('[data-navbar-target="search"]');
        setSearchState(target, false, trigger);
      }

      setMenuState('top-level-menu', false, false);
    }
  });
  
  // const observer = new IntersectionObserver((entries, observer) => {
  //   const entryClosestToTop = Array.from(entries).find((entry) => entry.intersectionRect.bottom >= header.clientHeight && entry.intersectionRect.top <= 0);
  //   if (!entryClosestToTop) { return; }
  //   const entry = entryClosestToTop.target;
  //   const entryScheme = entry.getAttribute('data-component-scheme');
  //   const newNavbarColor = entryScheme === 'dark' ? 'white' : 'black';
  //   header.style.setProperty('--C-color', newNavbarColor);
  // }, { threshold: 1.0 });
  // const schemeSections = Array.from(document.querySelectorAll('[data-component-scheme]'));
  // schemeSections.forEach((section) => observer.observe(section));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headline-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  Array.from(document.querySelectorAll('.v1-super-hero')).forEach(function (hero) {
    var wrap = hero.querySelector('.v1-super-hero__bottom-wrap');
    var section = hero.querySelector('.v1-super-hero__bottom');
    if (!wrap || !section) { return; }
    var slides = Array.from(section.querySelectorAll('[data-slide-index]'));
    if (slides.length < 2) { return; } // No scroll = no point!
    
    var indicatorsWrap = document.createElement('ol');
    indicatorsWrap.className = 'v1-super-hero__bottom-indicators';
    slides.forEach(function (slide, index) {
      var indicatorItem = document.createElement('li');
      indicatorItem.className = 'v1-super-hero__bottom-indicator-item';

      var indicatorButton = document.createElement('button');
      indicatorButton.type = 'button';
      indicatorButton.className = 'button--reset v1-super-hero__bottom-indicator-button';
      indicatorButton.setAttribute('data-slide-target', slide.getAttribute('data-slide-index'));
      indicatorButton.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      indicatorButton.innerHTML = '<span class="visually-hidden">Go to slide #'+slide.getAttribute('data-slide-index')+'</span>';

      indicatorItem.appendChild(indicatorButton);
      indicatorsWrap.appendChild(indicatorItem);
    });

    // Once we have our indicators, update the section to hide the scrollbar
    wrap.appendChild(indicatorsWrap)
    section.setAttribute('data-has-indicators', 'true');

    var scrollDebounce;
    section.addEventListener('scroll', function (e) {
      var scroller = e.target.closest('.v1-super-hero__bottom') || section;
      var container = scroller.closest('.v1-super-hero__bottom-container');
      
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        var scrollerHeight = scroller.clientHeight;
        var scrollerScroll = scroller.scrollTop;
        var scrollProgress = Math.round(scrollerScroll / scrollerHeight);

        setActiveIndicator(container, scrollProgress + 1); // Indices are 1-indexed
      }, 30);
    });

    section.addEventListener('muse:swipe', function (e) {
      var scroller = e.target.closest('.v1-super-hero__bottom') || section;
      var container = scroller.closest('.v1-super-hero__bottom-container');
      var indicators = container.querySelector('.v1-super-hero__bottom-indicators');
      var activeButton = indicators.querySelector('[data-slide-target][aria-pressed="true"]');
      var activeItem = activeButton.closest('.v1-super-hero__bottom-indicator-item');
      var prevItem = activeItem.previousElementSibling;
      var nextItem = activeItem.nextElementSibling;
      var targetItem = e.detail.swipeDirection.x === 'left' ? nextItem : prevItem;
      if (!targetItem) { return; } // At the end of the list, no more items!
      targetItem.querySelector('[data-slide-target]').click();
    });
  });

  function setActiveIndicator(container, index) {
    index = String(index || 0).trim();

    var button = container.querySelector('[data-slide-target="'+index+'"]');
    Array.from(container.querySelectorAll('[data-slide-target]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.v1-super-hero__bottom-indicator-button[data-slide-target]');
    if (!button) { return; }
    
    var container = button.closest('.v1-super-hero__bottom-container')
    var scroller = container.querySelector('.v1-super-hero__bottom');
    var slide = scroller.querySelector('[data-slide-index="'+button.getAttribute('data-slide-target')+'"]');
    var doAnimation = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) === false;
    
    slide.scrollIntoView({ behavior: doAnimation ? 'smooth' : 'instant', block: 'center' });
    setActiveIndicator(container, button.getAttribute('data-slide-target'));
  });

  // const thumbnailImages = document.querySelectorAll('.video-fullscreen-wrapper-thumbnail')
  // thumbnailImages.forEach(elem => {
  //   elem.addEventListener('click', () => {
  //     const videoId = elem.getAttribute('data-video-id')
  //     const modal = document.querySelector('.video-player-background')
  //     const modalContent = modal.querySelector('.player')
  //     if (window.customVideo.current != videoId) modalContent.innerHTML = window.customVideo[videoId]
  //     modal.style.display = 'block'
  //     if (modalContent.querySelector('video')) modalContent.querySelector('video').play()
  //     window.customVideo.current = videoId
  //   })
  // })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var userPrefersReducedMotion = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function startAutoplay(videos, toggle = false) {
      var isPlaying = Boolean(videos.find(function (v) { return !v.paused; }));
      videos.forEach(function(video) {
        video.setAttribute('autoplay', 'autoplay');
        
        if (window.getComputedStyle(video).display !== 'none') {
          if (isPlaying && toggle) { video.pause(); }
          else { video.play(); }
        }
      });
    }

    function addPlayButton(videos) {
      videos.forEach(function (hero) {
        var contentBlock = hero.querySelector('.v1-hero__content');
        if (contentBlock.querySelector('.v1-hero__play')) { return; } // There's already a button
        var heroVideos = Array.from(hero.querySelectorAll('video.v1-hero__image'));
        var playButton = document.createElement('button');
        playButton.type = 'button';
        playButton.className = 'button--reset v1-hero__play';
        playButton.innerHTML = '<span class="visually-hidden">Play/Pause video</span><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><title>Play/Pause video</title><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>';
        contentBlock.prepend(playButton);
        playButton.onclick = function() {
          startAutoplay(heroVideos, true);
        }
      });
    }

    var herosWithVideo = Array.from(document.querySelectorAll('.v1-hero')).filter(function (hero) { return hero.querySelector('video.v1-hero__image'); });
    if (userPrefersReducedMotion) {
      addPlayButton(herosWithVideo);
    } else {
      var heroVideos = Array.from(document.querySelectorAll('video.v1-hero__image'));
      startAutoplay(heroVideos);

      setTimeout(function() {
        if (heroVideos.filter(function (v) { return !v.paused; }).length === 0) {
          addPlayButton(herosWithVideo);
        }
      }, 3000);

      document.addEventListener('scroll', function() { startAutoplay(heroVideos); }, { once: true });
      document.addEventListener('click', function() { startAutoplay(heroVideos); }, { once: true });
      document.addEventListener('touchstart', function() { startAutoplay(heroVideos); }, { once: true });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var userPrefersReducedMotion = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function startAutoplay(videos, toggle = false) {
      var isPlaying = Boolean(videos.find(function (v) { return !v.paused; }));
      videos.forEach(function(video) {
        video.setAttribute('autoplay', 'autoplay');
        
        if (window.getComputedStyle(video).display !== 'none') {
          if (isPlaying && toggle) { video.pause(); }
          else { video.play(); }
        }
      });
    }

    function addPlayButton(videos) {
      videos.forEach(function (hero) {
        var contentBlock = hero.querySelector('.v2-hero__content');
        if (contentBlock.querySelector('.v2-hero__play')) { return; } // There's already a button
        var heroVideos = Array.from(hero.querySelectorAll('video.v2-hero__image'));
        var playButton = document.createElement('button');
        playButton.type = 'button';
        playButton.className = 'button--reset v2-hero__play';
        playButton.innerHTML = '<span class="visually-hidden">Play/Pause video</span><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><title>Play/Pause video</title><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>';
        contentBlock.prepend(playButton);
        playButton.onclick = function() {
          startAutoplay(heroVideos, true);
        }
      });
    }

    var herosWithVideo = Array.from(document.querySelectorAll('.v2-hero')).filter(function (hero) { return hero.querySelector('video.v2-hero__image'); });
    if (userPrefersReducedMotion) {
      addPlayButton(herosWithVideo);
    } else {
      var heroVideos = Array.from(document.querySelectorAll('video.v2-hero__image'));
      startAutoplay(heroVideos);

      setTimeout(function() {
        if (heroVideos.filter(function (v) { return !v.paused; }).length === 0) {
          addPlayButton(herosWithVideo);
        }
      }, 3000);

      document.addEventListener('scroll', function() { startAutoplay(heroVideos); }, { once: true });
      document.addEventListener('click', function() { startAutoplay(heroVideos); }, { once: true });
      document.addEventListener('touchstart', function() { startAutoplay(heroVideos); }, { once: true });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-strip-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Clone every logo strip's contents for a seamless marquee effect
  const logoStrips = Array.from(document.querySelectorAll('.v1-logo-strip:not([data-cloned])')).forEach(function (logoStrip) {
    const logos = logoStrip.querySelector('.v1-logo-strip__list');
    const copies = 1;
    for (var c = 0; c < copies ; c++) {
      Array.from(logos.children).forEach(function(item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true'); // Don't repeat the content for screen readers
        logos.appendChild(clone);
      });
    }
    logoStrip.setAttribute('data-cloned', 'true');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-strip-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Clone every logo strip's contents for a seamless marquee effect
  const logoStrips = Array.from(document.querySelectorAll('.v2-logo-strip:not([data-cloned])')).forEach(function (logoStrip) {
    const logos = logoStrip.querySelector('.v2-logo-strip__list');
    const copies = 1;
    for (var c = 0; c < copies ; c++) {
      Array.from(logos.children).forEach(function(item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true'); // Don't repeat the content for screen readers
        logos.appendChild(clone);
      });
    }
    logoStrip.setAttribute('data-cloned', 'true');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-container-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Start playing _muted and looping_ videos on scroll if not playing already
  var videosToStart = [];
  Array.from(document.querySelectorAll('video[muted][loop].v2-media-container__media')).forEach(function(video) {
    videosToStart.push(video);

    let observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        video.play();
      } else {
        video.pause();
      }
    }, { threshold: 0.25 });
    
    observer.observe(video);
  });
  var hasScrollBeenChecked = false;
  window.addEventListener('scroll', function() {
    if (hasScrollBeenChecked) { return; }
    hasScrollBeenChecked = true;
    setTimeout(function() {
      videosToStart.forEach(function(video) {
        video.setAttribute('preload', 'auto');
        video.setAttribute('autoplay', 'autoplay');
      });
    }, 150)
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-header-v2"] && !Shopify.designMode) return;
  try {
    
// Whenever [data-floating-header-logo] intersects with .shopify-section, check the background color and flip the nav if needed
document.addEventListener('DOMContentLoaded', function() {
	var header = document.querySelector('.v2-pdp-header__wrapper');
	// Unhide JS-only elements
	Array.from(header.querySelectorAll('[data-js-unhide][hidden]')).forEach(function(el) {
		el.hidden = false;
	});
	
	// Convert standard links into interactive buttons
	Array.from(header.querySelectorAll('a[data-anchor-to-button]')).forEach(function(a) {
		var button = document.createElement('button');
		button.type = 'button';

		// Copy all attributes...
		(Array.from(a.attributes) || []).forEach(function(attr) {
			// ...except the href and data-attribute marking the node for conversion
			if (attr.nodeName !== 'data-anchor-to-button' && attr.nodeName !== 'href') {
				button.setAttribute(attr.nodeName, attr.nodeValue);
			}
		});

		// Move all child nodes from the a into the button
		(Array.from(a.childNodes) || []).forEach(function(child) {
			button.append(child);
		});

		// Place the button right after the original a
		a.insertAdjacentElement('afterend', button);

		// Delete the original a
		a.parentElement.removeChild(a);
	});

	function setMenuState(menuId, isOpen, doFocus = true) {
		var menu = document.getElementById(menuId);
		if (isOpen) {
			menu.removeAttribute('inert');
			menu.classList.add('is-open');
			if (doFocus) {
				document.querySelector('[data-menu-action="close"]').focus();
			}
		} else {
			menu.setAttribute('inert', '');
			menu.classList.remove('is-open');
			if (doFocus) {
				document.querySelector('[data-menu-action="open"]').focus();
			}
		}
	}

	function setSearchState(searchForm, isOpen = null, onCloseFocus = false) {
		var oldOpenState = !searchForm.hidden;
		var wasClosed = oldOpenState === false;
		var newOpenState = isOpen === null ? !oldOpenState : Boolean(isOpen);
		var searchInput = searchForm.querySelector('input[name="q"]');
		searchForm.hidden = !newOpenState;
		
		if (newOpenState === true) {
			if (searchInput) {
				searchInput.focus();
			}
		} else if (newOpenState === false) {
			if (onCloseFocus) {
				onCloseFocus.focus();
			}
		}
	}

	document.addEventListener('click', function(e) {
		var target;
		if ((target = e.target.closest('[data-menu-action][data-menu-target]'))) {
			var targetAction = target.getAttribute('data-menu-action');
			var targetMenuId = target.getAttribute('data-menu-target');
			setMenuState(targetMenuId, targetAction === 'open');
		} else if ((target = e.target.closest('.v2-pdp-header__menu-link'))) {
			var targetMenuId = target.closest('.v2-pdp-header__menu-container').getAttribute('id');
			setMenuState(targetMenuId, false);
		} else if ((target = e.target.closest('[data-navbar-target="search"]'))) {
			var searchForm = target.closest('.v2-pdp-header__container').querySelector('[data-navbar-action="search"]');
			setSearchState(searchForm);
		} else if ((target = e.target.closest('[data-open-sidecart]'))) {
			e.preventDefault();
			e.stopPropagation();
			var sidecart = document.querySelector('.sidecart');
			sidecart.setAttribute('data-show', 'true');
		} else if ((target = e.target.closest('[data-close-sidecart]'))) {
			var sidecart = document.querySelector('.sidecart');
			sidecart.setAttribute('data-show', 'false');
		} else if ((target = e.target.closest('[data-checkout]'))) {
			function getCookie(h) {
					var match = document.cookie.match(new RegExp("(?:^|; )" + h.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
					return match ? match[1] : false;
			}

			var topLevelDomain = 'choosemuse.com';
			var subdomain = getCookie("_muse_store");
			window.location.href = `https://${subdomain && subdomain !== "us" ? subdomain+"." : ""}${topLevelDomain}/checkout`;
		}
		//! after this series of conditions, `target` can be null or a matching element, do not rely on its value

		// Force close the search if clicking outside
		if (e.target && !e.target.closest('[data-navbar-target="search"], [data-navbar-action="search"]')) {
			var formToClose = document.querySelector('[data-navbar-action="search"]');
			if (formToClose) {
				setSearchState(formToClose, false);
			}
		}
	});

	document.addEventListener('keyup', function(e) {
		var target;
		if (e.key === 'Escape') {
			if ((target = e.target.closest('[data-navbar-action="search"]'))) {
				var wrapper = target.closest('.v2-pdp-header__wrapper');
				var trigger = wrapper.querySelector('[data-navbar-target="search"]');
				setSearchState(target, false, trigger);
			}

			setMenuState('top-level-menu', false, false);
		}
	});

	function setHeaderState(showAlt = false) {
		var header = document.querySelector('.v2-pdp-header__wrapper');
		header.setAttribute('data-show-alt', Boolean(showAlt).toString());
	}
	setHeaderState();

	var scrollTarget = document.querySelector('.v2-pdp-container__info-price');
	var scrollTargetPos = scrollTarget.getBoundingClientRect();
	var scrollTargetPosY = scrollTargetPos.y;
	var headerHeight = header.clientHeight;
	var scrollThreshold = Math.max(150, scrollTargetPosY - headerHeight); // At least 150px but no further than  after hiding the price
	var lastScroll = 0;
	var scrollDebouncer = null;
	window.addEventListener('scroll', function(e) {
		clearTimeout(scrollDebouncer);
		scrollDebouncer = setTimeout(function() {
			var newScroll = document.documentElement.scrollTop;
			var dir = newScroll > lastScroll ? 1 : -1;
			var isPastThreshold = newScroll > scrollThreshold;
			setHeaderState(dir > 0 && isPastThreshold);
			lastScroll = newScroll;
		}, 10);
	});

	function calcHeaderHeight() {
		var navbar = document.querySelector('.v2-pdp-header__wrapper');
		if (!navbar) { return; }
		var navbarHeight = navbar.clientHeight || 0; // Pure number, unitless value in pixels
		document.documentElement.style.setProperty('--MUSE-navbar-height', navbarHeight);
	}
	calcHeaderHeight();

	var resizeDebouncer = null;
	window.addEventListener('resize', function(e) {
		clearTimeout(resizeDebouncer);
		resizeDebouncer = setTimeout(function() {
			calcHeaderHeight();
		}, 100);
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-toggle-v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function (e) {
    Array.from(document.querySelectorAll('.v1-product-card-toggle__toggle-content-close')).forEach(function(close) {
      close.hidden = false;
    });

    Array.from(document.querySelectorAll('.v1-product-card-toggle__toggle-wrapper')).forEach(function (details) {
      details.addEventListener('toggle', function(e) {
        if (e.newState === 'open') {
        } else if (e.newState === 'closed') {
          Array.from(details.querySelectorAll('[data-enter-anim]')).forEach(function (el) { el.setAttribute('data-enter-anim', 'off'); });
        }
      });
    });
  });
  
  document.addEventListener('click', function (e) {
    var target;
    if ((target = e.target.closest('.v1-product-card-toggle__toggle-content-close')) || e.target.matches('.v1-product-card-toggle__toggle-content')) {
      if (e.target.matches('.v1-product-card-toggle__toggle-content')) { target = e.target; }
      if (!target) { return; }
      var details = target.closest('details[open]');
      if (!details) { return; }
      var summary = details.querySelector('summary');
      if (!summary) { return; }
      summary.click(); // If it's open, close it via the summary
    } else if ((target = e.target.closest('.v1-product-card-toggle__toggle-button'))) {
      var userAllowsMotion = Boolean(window.matchMedia('(prefers-reduced-motion: no-preference)').matches);
      if (userAllowsMotion) {
        var details = target.closest('details');
        var animatables = Array.from(details.querySelectorAll('[data-enter-anim]'));
        // Keep them invisible but display is no longer `none`
        animatables.forEach(function (el) { el.style.opacity = '0'; });
        requestAnimationFrame(function(){
          // Apply the animation class
          animatables.forEach(function (el) { el.setAttribute('data-enter-anim', 'on'); });
          requestAnimationFrame(function(){
            // Remove the inline opacity style
            animatables.forEach(function (el) {  el.style.opacity = ''; });
          });
        });
      }
    }
  });

  document.addEventListener('focusin', function(e) {
    var target = e.target.closest('.v1-product-card-toggle');
    if (!target) { return; }
    var openPopup = target.querySelector('.v1-product-card-toggle__toggle-wrapper[open]');
    var isFocusInsidePopup = !!e.target.closest('.v1-product-card-toggle__toggle-content');
    if (!openPopup || isFocusInsidePopup) { return; }
    var summary = openPopup.querySelector('summary');
    summary.click();
  });

  document.addEventListener('keyup', function(e) {
    var target;
    if (e.key === 'Escape') {
      if ((target = document.querySelector('.v1-product-card-toggle__toggle-wrapper[open]'))) {
        var summary = target.querySelector('summary');
        summary.click();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-toggle-v2"] && !Shopify.designMode) return;
  try {
    
// New
document.addEventListener('DOMContentLoaded', function (e) {
    Array.from(document.querySelectorAll('.v1-product-card-toggle__toggle-content-close')).forEach(function(close) {
      close.hidden = false;
    });

    Array.from(document.querySelectorAll('.v1-product-card-toggle__toggle-wrapper')).forEach(function (details) {
      details.addEventListener('toggle', function(e) {
        if (e.newState === 'open') {
        } else if (e.newState === 'closed') {
          Array.from(details.querySelectorAll('[data-enter-anim]')).forEach(function (el) { el.setAttribute('data-enter-anim', 'off'); });
        }
      });
    });
  });
  
  document.addEventListener('click', function (e) {
    var target;
    if ((target = e.target.closest('.v1-product-card-toggle__toggle-content-close')) || e.target.matches('.v1-product-card-toggle__toggle-content')) {
      if (e.target.matches('.v1-product-card-toggle__toggle-content')) { target = e.target; }
      if (!target) { return; }
      var details = target.closest('details[open]');
      if (!details) { return; }
      var summary = details.querySelector('summary');
      if (!summary) { return; }
      summary.click(); // If it's open, close it via the summary
    } else if ((target = e.target.closest('.v1-product-card-toggle__toggle-button'))) {
      var userAllowsMotion = Boolean(window.matchMedia('(prefers-reduced-motion: no-preference)').matches);
      if (userAllowsMotion) {
        var details = target.closest('details');
        var animatables = Array.from(details.querySelectorAll('[data-enter-anim]'));
        // Keep them invisible but display is no longer `none`
        animatables.forEach(function (el) { el.style.opacity = '0'; });
        requestAnimationFrame(function(){
          // Apply the animation class
          animatables.forEach(function (el) { el.setAttribute('data-enter-anim', 'on'); });
          requestAnimationFrame(function(){
            // Remove the inline opacity style
            animatables.forEach(function (el) {  el.style.opacity = ''; });
          });
        });
      }
    }
  });

  document.addEventListener('focusin', function(e) {
    var target = e.target.closest('.v1-product-card-toggle');
    if (!target) { return; }
    var openPopup = target.querySelector('.v1-product-card-toggle__toggle-wrapper[open]');
    var isFocusInsidePopup = !!e.target.closest('.v1-product-card-toggle__toggle-content');
    if (!openPopup || isFocusInsidePopup) { return; }
    var summary = openPopup.querySelector('summary');
    summary.click();
  });

  document.addEventListener('keyup', function(e) {
    var target;
    if (e.key === 'Escape') {
      if ((target = document.querySelector('.v1-product-card-toggle__toggle-wrapper[open]'))) {
        var summary = target.querySelector('summary');
        summary.click();
      }
    }
  });
// New
  document.addEventListener('DOMContentLoaded', function() {
    if (window.location.search.indexOf('discount=') < 0) { return; }
    try {
      // Find the discount code in the URL first
      var currentHref = new URL(window.location.href);
      var currentParams = currentHref.searchParams;
      var currentDiscount = currentParams.get('discount');

      // Once retrieved, delete the discount from the URL to keep it clean
      //!!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!!
      //!! Commented out: keeping the URL param for redirects across regional stores !!
      //!!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !!!
      // currentParams.delete('discount');
      // var currentHrefWithoutDiscount = currentHref.toString();
      // window.history.replaceState({}, document.title, currentHrefWithoutDiscount);

      // Then update all links with a discount in their href
      Array.from(document.querySelectorAll('[href][data-href-discount]')).forEach(function(hrefWithDiscount) {
        var hrefAttr = hrefWithDiscount.getAttribute('href');
        var discountCode = hrefWithDiscount.getAttribute('data-href-discount');
        var updatedHref = hrefAttr.replace(`discount=${discountCode}`, `discount=${currentDiscount}`);
        hrefWithDiscount.setAttribute('href', updatedHref);
      });

      // Also adding a cookie for redundency
      document.cookie = `discount_code=${currentDiscount}`;
    } catch (err) {
      console.log('Unable to parse and apply discount code:');
      console.error(err);
    }
  });
  
  document.addEventListener('click', function (e) {
    var target = e.target.closest('.v2-product-card-toggle__toggle-button[data-goto-product]');
    if (!target) { return; }
    var targetIndex = target.getAttribute('data-goto-product');
    var toggler = target.closest('.v2-product-card-toggle');
    var allTargets = Array.from(toggler.querySelectorAll('.v2-product-card-toggle__toggle-button[data-goto-product]'));
    allTargets.forEach(function (button) {
      var isPressed = button.getAttribute('data-goto-product') === targetIndex;
      button.setAttribute('aria-pressed', Boolean(isPressed).toString());
    });
    var targetScroller = toggler.querySelector('.v2-product-card-toggle__cards-wrapper');
    var targetCard = toggler.querySelector('.v2-product-card-toggle__card[data-target-product="'+targetIndex+'"]');
    var cardCount = Array.from(targetScroller.querySelectorAll('.v2-product-card-toggle__card')).length;
    var maxScroll = targetScroller.scrollWidth - targetScroller.clientWidth;
    var targetIndex0 = targetIndex - 1; // Zero-indexed
    var scrollStep = maxScroll / (cardCount - 1);
    var scrollTarget = targetIndex0 * scrollStep;

    setTimeout(function() {
      targetScroller.scrollTo({
        left: scrollTarget,
        behavior: Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth',
      });
      targetCard.focus();
      
       targetCard.scrollIntoView({
         behavior: Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth',
         block: 'center',
         inline: 'center',
      });
    }, 50);
  });

  Array.from(document.querySelectorAll('.v2-product-card-toggle__cards-wrapper')).forEach(function (targetScroller) {
    var debounced;
    targetScroller.addEventListener('scroll', function(e) {
      clearTimeout(debounced);
      debounced = setTimeout(function() {
        var cardCount = Array.from(targetScroller.querySelectorAll('.v2-product-card-toggle__card')).length;
        var maxScroll = targetScroller.scrollWidth - targetScroller.clientWidth;
        var scrollStep = maxScroll / (cardCount - 1);
        var scrollLeft = targetScroller.scrollLeft + 0.0001;
        var closestIndex = Math.floor(scrollLeft / scrollStep) + 1; // To one-indexed
        var toggler = targetScroller.closest('.v2-product-card-toggle');
        var allTargets = Array.from(toggler.querySelectorAll('.v2-product-card-toggle__toggle-button[data-goto-product]'));
        allTargets.forEach(function (button) {
          var isPressed = button.getAttribute('data-goto-product') === String(closestIndex);
          button.setAttribute('aria-pressed', Boolean(isPressed).toString());
        });
      }, 200);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-toggle-v3"] && !Shopify.designMode) return;
  try {
    
// Fee variant constant
// const FEE_VARIANT_ID = "51909305860463";

// Discount Fee Button Logic
document.addEventListener('DOMContentLoaded', function () {
  let isProcessingFeeButton = false;

  // Auto-accept fee popup
  function autoAcceptPopup() {
    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && node.matches('dialog.ma-fees__dialog--confirmation')) {
            const btn = node.querySelector('[data-action="accept"]');
            if (btn) btn.click();
            obs.disconnect();
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // Wait until fee appears in cart
  // function waitForFee(timeout = 5000) {
  //   return new Promise(resolve => {
  //     const start = Date.now();

  //     const loop = () => {
  //       fetch('/cart.js')
  //         .then(res => res.json())
  //         .then(cart => {
  //           const exists = cart.items.some(i => String(i.variant_id) === FEE_VARIANT_ID);
  //           if (exists) return resolve(true);

  //           if (Date.now() - start > timeout) return resolve(false);
  //           setTimeout(loop, 200);
  //         })
  //         .catch(() => setTimeout(loop, 200));
  //     };

  //     loop();
  //   });
  // }

  // Clear cart completely
  async function clearCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const updates = {};
    cart.items.forEach(item => {
      updates[item.id] = 0;
    });
    
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  // Use event delegation to handle clicks on visible buttons only
  document.addEventListener('click', async function(e) {
    const button = e.target.closest('.add-discount-with-fee');
    
    // Check if button exists, is visible, and not already processing
    if (!button) return;
    if (window.getComputedStyle(button).display === 'none') return;
    if (isProcessingFeeButton) return;
    
    e.preventDefault();
    e.stopImmediatePropagation();
    
    // Prevent duplicate clicks globally
    if (button.dataset.clicked === "true") return;
    button.dataset.clicked = "true";
    isProcessingFeeButton = true;
    
    button.classList.add("loading");
    button.style.pointerEvents = "none";

    const variantId = button.dataset.variantId;
    const discount = button.dataset.discount || "";

    console.log('Processing fee button click for variant:', variantId);

    autoAcceptPopup();

    try {
      // Step 1: Clear the entire cart first
      await clearCart();
      
      // Step 2: Add product (discount will apply to this)
      await fetch('/cart/add.js', {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: variantId, 
          quantity: 1
        })
      });

      // Step 3: Add fee with special properties to mark it as a fee
      // This helps Shopify identify it should not be discounted
      // await fetch('/cart/add.js', {
      //   method: "POST",
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ 
      //     id: FEE_VARIANT_ID, 
      //     quantity: 1,
      //     properties: {
      //       '_fee': 'true',
      //       '_no_discount': 'true'
      //     }
      //   })
      // });
      
      // Wait for fee to appear in cart
      // await waitForFee();
      
      // Step 4: Redirect to checkout with discount
      const checkoutUrl = discount
        ? "/checkout?discount=" + encodeURIComponent(discount)
        : "/checkout";

      console.log('Redirecting to checkout with discount:', discount);
      window.location.href = checkoutUrl;
      
    } catch (err) {
      console.error("Add error", err);
      isProcessingFeeButton = false;
      button.dataset.clicked = "false";
      button.classList.remove("loading");
      button.style.pointerEvents = "auto";
      return;
    }
  });
});

// Solo/Bundle Dropdown Logic
var showcaseSections = document.querySelectorAll('.v3-product-card-toggle');

showcaseSections.forEach(function(section) {
  var currentVariant = section.getAttribute('data-showcase-selected');

  // Function to update the UI for a specific variant
  function updateVariantUI(card, variant) {
    // card.querySelectorAll('[data-variant-title]').forEach(function(title) {
    //   title.style.display = title.getAttribute('data-variant-title') === variant ? 'block' : 'none';
    // });
    // card.querySelectorAll('[data-variant-content]').forEach(function(content) {
    //   content.style.display = content.getAttribute('data-variant-content') === variant ? 'block' : 'none';
    // });
    // card.querySelectorAll('[data-switch-to]').forEach(function(button) {
    //   button.style.display = button.getAttribute('data-current-variant') === variant ? 'block' : 'none';
    // });
  }

  section.querySelectorAll('.v3-product-card-toggle__card').forEach(function(card) {
    updateVariantUI(card, currentVariant);
  });


  function collapseDropdown(dropdown) {
    if (!dropdown) return;
    
    var header = dropdown.querySelector('[data-dropdown-header]');
    var content = dropdown.querySelector('[data-dropdown-content]');
    var chevron = dropdown.querySelector('[data-chevron-icon]');

    if (!header || !content) return;

    content.style.maxHeight = null;
    content.classList.remove('open');
    header.setAttribute('aria-expanded', 'false');
    if (chevron) chevron.classList.remove('rotated');
  }

  section.querySelectorAll('[data-dropdown-header]').forEach(function(header) {
    header.setAttribute('aria-expanded', 'false');
    header.addEventListener('click', function() {
      var dropdown = header.closest('[data-variant-dropdown]');
      var content = dropdown.querySelector('[data-dropdown-content]');
      var chevrons = dropdown.querySelectorAll('[data-chevron-icon]');
      var isExpanded = header.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        content.style.maxHeight = null;
        content.classList.remove('open');
        header.setAttribute('aria-expanded', 'false');
        chevrons.forEach(function(icon) {
          icon.classList.remove('rotated');
        });
      } else {
        content.classList.add('open');
        header.setAttribute('aria-expanded', 'true');
        chevrons.forEach(function(icon) {
          icon.classList.add('rotated');
        });
      }
    });
  });

  // SWITCH-TO LOGIC (now uses the same collapse)
section.querySelectorAll('[data-switch-to]').forEach(function(button) {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var selected = button.getAttribute('data-switch-to'); 
    var dropdown = button.closest('[data-variant-dropdown]');
    
    // Update the closest product card (original behavior)
    var currentCard = button.closest('.v3-product-card-toggle__card');
    if (currentCard) {
      updateVariantUI(currentCard, selected);
      updateCardVariant(currentCard, selected);
    }

    // Handle dropdown toggle behavior
    if (!dropdown) return;
    
    var header = dropdown.querySelector('[data-dropdown-header]') || dropdown.querySelector('.dropdown-header');
    var content = dropdown.querySelector('[data-dropdown-content]');
    var chevrons = dropdown.querySelectorAll('[data-chevron-icon]');

    if (selected === "solo") {
      // Collapse dropdown for solo
      if (content) {
        content.style.maxHeight = null;
        content.classList.remove('open');
      }
      if (header) header.setAttribute('aria-expanded', 'false');
      chevrons.forEach(function(icon) {
        icon.classList.remove('rotated');
      });
      
      // Trigger solo color option - SCOPED TO CURRENT CARD
      if (currentCard) {
        const soloLabel = currentCard.querySelector('.color-option[data-color="carbon"][data-showcase-variant="solo"]');
        if (soloLabel) {
          soloLabel.click();
        }
      }
    } 
    else if (selected === "bundle") {
      // Expand dropdown for bundle
      if (content) {
        content.classList.add('open');
      }
      if (header) header.setAttribute('aria-expanded', 'true');
      chevrons.forEach(function(icon) {
        icon.classList.add('rotated');
      });
      
      // Trigger bundle color option - SCOPED TO CURRENT CARD
      if (currentCard) {
        const bundleLabel = currentCard.querySelector('.color-option[data-color="carbon"][data-showcase-variant="bundle"]');
        if (bundleLabel) {
          bundleLabel.click();
        }
      }
    }
  });
});

  // section.querySelectorAll('[data-switch-to]').forEach(function(button) {
  //   button.addEventListener('click', function(e) {
  //     e.preventDefault();
  //     var newVariant = button.getAttribute('data-switch-to');
      
  //     var currentCard = button.closest('.v3-product-card-toggle__card');
      
  //     if (currentCard) {
  //       updateVariantUI(currentCard, newVariant);
  //       updateCardVariant(currentCard, newVariant);
  //     }

  //     var dropdown = button.closest('[data-variant-dropdown]');
  //     var header = dropdown.querySelector('[data-dropdown-header]');
  //     var content = dropdown.querySelector('[data-dropdown-content]');
  //     var chevron = dropdown.querySelector('[data-chevron-icon]');
  //     content.style.maxHeight = null;
  //     content.classList.remove('open');
  //     header.setAttribute('aria-expanded', 'false');
  //     if (chevron) chevron.classList.remove('rotated');
  //   });
  // });
});

// Discount Code Logic
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.search.indexOf('discount=') < 0) { return; }
  try {
    var currentHref = new URL(window.location.href);
    var currentParams = currentHref.searchParams;
    var currentDiscount = currentParams.get('discount');

    Array.from(document.querySelectorAll('[href][data-href-discount]')).forEach(function(hrefWithDiscount) {
      var hrefAttr = hrefWithDiscount.getAttribute('href');
      var discountCode = hrefWithDiscount.getAttribute('data-href-discount');
      var updatedHref = hrefAttr.replace(`discount=${discountCode}`, `discount=${currentDiscount}`);
      hrefWithDiscount.setAttribute('href', updatedHref);
    });

    document.cookie = `discount_code=${currentDiscount}`;
  } catch (err) {
    console.log('Unable to parse and apply discount code:');
    console.error(err);
  }
});

// Product Navigation Logic
document.addEventListener('click', function (e) {
  var target = e.target.closest('.v3-product-card-toggle__toggle-button[data-goto-product]');
  if (!target) { return; }
  
  var targetIndex = target.getAttribute('data-goto-product');
  var toggler = target.closest('.v3-product-card-toggle');
  var allTargets = Array.from(toggler.querySelectorAll('.v3-product-card-toggle__toggle-button[data-goto-product]'));
  
  allTargets.forEach(function (button) {
    var isPressed = button.getAttribute('data-goto-product') === targetIndex;
    button.setAttribute('aria-pressed', Boolean(isPressed).toString());
  });
  
  var targetScroller = toggler.querySelector('.v3-product-card-toggle__cards-wrapper');
  var targetCard = toggler.querySelector('.v3-product-card-toggle__card[data-target-product="'+targetIndex+'"]');
  var cardCount = Array.from(targetScroller.querySelectorAll('.v3-product-card-toggle__card')).length;
  var maxScroll = targetScroller.scrollWidth - targetScroller.clientWidth;
  var targetIndex0 = targetIndex - 1;
  var scrollStep = maxScroll / (cardCount - 1);
  var scrollTarget = targetIndex0 * scrollStep;

  setTimeout(function() {
    targetScroller.scrollTo({
      left: scrollTarget,
      behavior: Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth',
    });
    targetCard.focus();
    targetCard.scrollIntoView({
      behavior: Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth',
      block: 'center',
      inline: 'center',
    });
  }, 50);
});

// Scroll Sync Logic
Array.from(document.querySelectorAll('.v3-product-card-toggle__cards-wrapper')).forEach(function (targetScroller) {
  var debounced;
  targetScroller.addEventListener('scroll', function(e) {
    clearTimeout(debounced);
    debounced = setTimeout(function() {
      var cardCount = Array.from(targetScroller.querySelectorAll('.v3-product-card-toggle__card')).length;
      var maxScroll = targetScroller.scrollWidth - targetScroller.clientWidth;
      var scrollStep = maxScroll / (cardCount - 1);
      var scrollLeft = targetScroller.scrollLeft + 0.0001;
      var closestIndex = Math.floor(scrollLeft / scrollStep) + 1;
      var toggler = targetScroller.closest('.v3-product-card-toggle');
      var allTargets = Array.from(toggler.querySelectorAll('.v3-product-card-toggle__toggle-button[data-goto-product]'));
      
      allTargets.forEach(function (button) {
        var isPressed = button.getAttribute('data-goto-product') === String(closestIndex);
        button.setAttribute('aria-pressed', Boolean(isPressed).toString());
      });
    }, 200);
  });
});

// Update card variant display and featured image (GLOBAL FUNCTION)
function updateCardVariant(card, variant) {
  // Update the card's data attribute - CSS will handle visibility
  // The card itself will now hold the selection state to prevent global updates
  card.setAttribute('data-card-selected', variant);

  var productImage = card.querySelector('.v3-product-card-toggle__product-photo');
  var productLink = card.querySelector('.v3-product-card-toggle__images a');
  
  if (productImage) {
    var soloImageUrl = productImage.getAttribute('data-solo-image');
    var bundleImageUrl = productImage.getAttribute('data-bundle-image');
    
    var selectedColorInput = card.querySelector('.color-option[data-showcase-variant="' + variant + '"] input:checked');
    
    if (selectedColorInput && selectedColorInput.getAttribute('data-variant-image')) {
      productImage.src = selectedColorInput.getAttribute('data-variant-image');
    } else {
      if (variant === 'solo' && soloImageUrl) {
        productImage.src = soloImageUrl;
      } else if (variant === 'bundle' && bundleImageUrl) {
        productImage.src = bundleImageUrl;
      }
    }
  }

  if (productLink) {
    var soloUrl = productLink.getAttribute('data-solo-url');
    var bundleUrl = productLink.getAttribute('data-bundle-url');
    
    if (variant === 'solo' && soloUrl) {
      productLink.href = soloUrl;
    } else if (variant === 'bundle' && bundleUrl) {
      productLink.href = bundleUrl;
    }
  }

  // Update variant IDs for buttons
  var selectedColorInput = card.querySelector('.color-option[data-showcase-variant="' + variant + '"] input:checked');
  if (selectedColorInput) {
    var variantId = selectedColorInput.value;
    
    var feeButton = card.querySelector('.add-discount-with-fee[data-showcase-variant="' + variant + '"]');
    if (feeButton) {
      feeButton.setAttribute('data-variant-id', variantId);
      console.log('Updated fee button variant ID to:', variantId);
    }
    
    var addToCartBtn = card.querySelector('button[data-add-to-cart][data-showcase-variant="' + variant + '"]');
    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-product_id', variantId);
    }
  }
}

// Variant and Color Selection Logic
document.querySelectorAll('.switch-to-solo, .switch-to-bundle').forEach(function(button) {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    var newVariant = this.getAttribute('data-switch-to') || this.getAttribute('data-target-variant');
    var card = this.closest('.v3-product-card-toggle__card');

    if (card) {
      updateCardVariant(card, newVariant);
      
      var selectedColorInput = card.querySelector('.color-option[data-showcase-variant="' + newVariant + '"] input:checked');
      if (selectedColorInput) {
        var variantId = selectedColorInput.value;
        var addToCartBtn = card.querySelector('button[data-add-to-cart][data-showcase-variant="' + newVariant + '"]');
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-product_id', variantId);
        }
      }
    }
  });
});

// Handle color selection using CLICK on labels
document.addEventListener('click', function(e) {
  var colorOption = e.target.closest('.color-option');
  if (colorOption) {
    var input = colorOption.querySelector('input[type="radio"]');
    if (!input) return;
    
    console.log('=== COLOR CLICKED ===');
    console.log('Color value:', input.value);
    
    var card = colorOption.closest('.v3-product-card-toggle__card');
    if (!card) {
      console.log('ERROR: Card not found');
      return;
    }
    
    var variantType = colorOption.getAttribute('data-showcase-variant');
    if (!variantType) {
      console.log('ERROR: No variant type found');
      return;
    }
    
    var variantId = input.value;
    var variantImageUrl = input.getAttribute('data-variant-image');
    
    console.log('Variant type:', variantType);
    console.log('Variant ID:', variantId);
    console.log('Image URL:', variantImageUrl);

    var productImage = card.querySelector('.v3-product-card-toggle__product-photo');
    if (productImage && variantImageUrl) {
      console.log('Updating image to:', variantImageUrl);
      productImage.src = variantImageUrl;
    }

    var addToCartBtn = card.querySelector('button[data-add-to-cart][data-showcase-variant="' + variantType + '"]');
    if (addToCartBtn) {
      console.log('Updating button data-product_id to:', variantId);
      addToCartBtn.setAttribute('data-product_id', variantId);
      addToCartBtn.setAttribute('data-variant-id', variantId);
    }
    
    var feeButton = card.querySelector('.add-discount-with-fee[data-showcase-variant="' + variantType + '"]');
    if (feeButton) {
      console.log('Updating fee button to variant:', variantId);
      feeButton.setAttribute('data-variant-id', variantId);
    }
    
    console.log('=== UPDATE COMPLETE ===');
  }
});

// Initialize on load
document.querySelectorAll('.v3-product-card-toggle').forEach(function(container) {
  var selectedVariant = container.getAttribute('data-showcase-selected') || 'solo';

  container.querySelectorAll('.v3-product-card-toggle__card').forEach(function(card) {
    updateCardVariant(card, selectedVariant);

    var colorInputs = card.querySelectorAll('.color-option[data-showcase-variant="' + selectedVariant + '"] input[type="radio"]');
    if (colorInputs.length > 0) {
      var checkedInput = card.querySelector('.color-option[data-showcase-variant="' + selectedVariant + '"] input:checked');
      
      if (!checkedInput) {
        colorInputs[0].checked = true;
        checkedInput = colorInputs[0];
      }
      
      if (checkedInput) {
        var variantId = checkedInput.value;
        var variantImageUrl = checkedInput.getAttribute('data-variant-image');
        
        var addToCartBtn = card.querySelector('button[data-add-to-cart][data-showcase-variant="' + selectedVariant + '"]');
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-product_id', variantId);
          addToCartBtn.setAttribute('data-variant-id', variantId);
        }
        
        var feeButton = card.querySelector('.add-discount-with-fee[data-showcase-variant="' + selectedVariant + '"]');
        if (feeButton) {
          feeButton.setAttribute('data-variant-id', variantId);
        }
        
        if (variantImageUrl) {
          var productImage = card.querySelector('.v3-product-card-toggle__product-photo');
          if (productImage) {
            productImage.src = variantImageUrl;
          }
        }
      }
    }
  });
});

document.addEventListener('click', function (e) {
  var target = e.target.closest('.v3-product-card-toggle__toggle-button[data-goto-product]');
  if (!target) { return; }
  var targetIndex = target.getAttribute('data-goto-product');
  var toggler = target.closest('.v3-product-card-toggle');
  var allTargets = Array.from(toggler.querySelectorAll('.v3-product-card-toggle__toggle-button[data-goto-product]'));
  
  allTargets.forEach(function (button) {
    var isPressed = button.getAttribute('data-goto-product') === targetIndex;
    button.setAttribute('aria-pressed', Boolean(isPressed).toString());
  });
  
  var targetScroller = toggler.querySelector('.v3-product-card-toggle__cards-wrapper');
  var targetCard = toggler.querySelector('.v3-product-card-toggle__card[data-switch-product="'+targetIndex+'"]');
  var cardCount = Array.from(targetScroller.querySelectorAll('.v3-product-card-toggle__card')).length;
  var maxScroll = targetScroller.scrollWidth - targetScroller.clientWidth;
  var targetIndex0 = targetIndex - 1; // Zero-indexed
  var scrollStep = maxScroll / (cardCount - 1);
  var scrollTarget = targetIndex0 * scrollStep;

  setTimeout(function() {
    targetScroller.scrollTo({
      left: scrollTarget,
      behavior: Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth',
    });
    if (targetCard) {
      targetCard.focus();
      
      targetCard.scrollIntoView({
        behavior: Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }, 50);
});

Array.from(document.querySelectorAll('.v3-product-card-toggle__cards-wrapper')).forEach(function (targetScroller) {
  var debounced;
  targetScroller.addEventListener('scroll', function(e) {
    clearTimeout(debounced);
    debounced = setTimeout(function() {
      var cardCount = Array.from(targetScroller.querySelectorAll('.v3-product-card-toggle__card')).length;
      var maxScroll = targetScroller.scrollWidth - targetScroller.clientWidth;
      var scrollStep = maxScroll / (cardCount - 1);
      var scrollLeft = targetScroller.scrollLeft + 0.0001;
      var closestIndex = Math.floor(scrollLeft / scrollStep) + 1; // To one-indexed
      var toggler = targetScroller.closest('.v3-product-card-toggle');
      var allTargets = Array.from(toggler.querySelectorAll('.v3-product-card-toggle__toggle-button[data-goto-product]'));
      
      allTargets.forEach(function (button) {
        var isPressed = button.getAttribute('data-goto-product') === String(closestIndex);
        button.setAttribute('aria-pressed', Boolean(isPressed).toString());
      });
    }, 200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-v2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(e) {
  // Convert standard links into interactive buttons
  Array.from(document.querySelectorAll('a.v2-pdp-container__media-carousel-button--thumb')).forEach(function(a) {
    var button = document.createElement('button');
    button.type = 'button';

    // Copy all attributes...
    (Array.from(a.attributes) || []).forEach(function(attr) {
      // ...except the href and data-attribute marking the node for conversion
      if (['target', 'href', 'data-active'].includes(attr.nodeName) === false) {
        button.setAttribute(attr.nodeName, attr.nodeValue);
      }
    });
    button.setAttribute('aria-pressed', a.getAttribute('data-active'));

    // Move all child nodes from the a into the button
    (Array.from(a.childNodes) || []).forEach(function(child) {
      button.append(child);
    });

    // Place the button right after the original a
    a.insertAdjacentElement('afterend', button);

    // Delete the original a
    a.parentElement.removeChild(a);
  });

  function getIsLargeViewport() {
    return window.matchMedia('(min-width: 740px)').matches;
  }
  function getHasScroll(el) {
    var hasHorizontalScrollbar = el.scrollWidth > el.clientWidth;
    var hasVerticalScrollbar = el.scrollHeight > el.clientHeight;
    return { x: hasHorizontalScrollbar, y: hasVerticalScrollbar };
  }
  // Handle change in selected media item
  function setActiveMediaGalleryItem(config) {
    var gallery = config.gallery;
    var scroller = gallery.querySelector('.v2-pdp-container__media-carousel-scroller');
    var activeMedia = config.activeMedia;
    var activeMediaId = config.activeMedia.getAttribute('data-media-id');
    var targetMediaId = config.targetMediaId;
    if (targetMediaId === '+' || targetMediaId === '-') {
      if (targetMediaId === '+') {
        var siblingMedia = activeMedia.nextElementSibling;
        if (!siblingMedia) { siblingMedia = activeMedia.parentElement.querySelector(':scope > :first-child'); }
      } else if (targetMediaId === '-') {
        var siblingMedia = activeMedia.previousElementSibling;
        if (!siblingMedia) { siblingMedia = activeMedia.parentElement.querySelector(':scope > :last-child'); }
      }
      targetMediaId = siblingMedia ? siblingMedia.getAttribute('data-media-id') : activeMediaId;
    }
    if (activeMedia.tagName === 'VIDEO') { activeMedia.pause(); }
    gallery.querySelector('.v2-pdp-container__media-content[data-active="true"]').setAttribute('data-active', 'false');
    gallery.querySelector('.v2-pdp-container__media-carousel-button--thumb[aria-pressed="true"]').setAttribute('aria-pressed', 'false');
    var targetMedia = gallery.querySelector('[data-media-id="'+targetMediaId+'"]');
    var targetButton = gallery.querySelector('[data-media-target="'+targetMediaId+'"]');
    targetMedia.setAttribute('data-active', 'true');
    targetButton.setAttribute('aria-pressed', 'true');
    if (targetMedia.tagName === 'VIDEO') { targetMedia.play(); }
    var hasScroll = getHasScroll(scroller);
    if (hasScroll.x || hasScroll.y) {
      // Don't trigger scrollIntoView if there is no scrollbar
      if (getIsLargeViewport() && !hasScroll.y) { return; }
      if (!getIsLargeViewport() && !hasScroll.x) { return; }
      
      var scrollOptions = { behavior: 'smooth', block: 'nearest', inline: 'center' };
      if (getIsLargeViewport()) { delete scrollOptions.inline; } // Don't trigger horizontal scrolling in large viewports
      targetButton.scrollIntoView(scrollOptions);
    }
    var targetImage = targetButton.querySelector('img');
    var largeMediaContainer = gallery.querySelector('.v2-pdp-container__media-large');
    largeMediaContainer.style.backgroundImage = 'url('+targetImage.src+')';
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-media-target]');
    if (!target) { return; }
    var gallery = target.closest('.v2-pdp-container__media');
    var targetMediaId = target.getAttribute('data-media-target');
    var activeButton = gallery.querySelector('.v2-pdp-container__media-carousel-button--thumb[aria-pressed="true"]');
    var activeMedia = gallery.querySelector('.v2-pdp-container__media-content[data-active="true"]');
    if (target === activeButton || activeMedia.getAttribute('data-media-id') === targetMediaId) { return; }
    if (!targetMediaId) { return; }
    setActiveMediaGalleryItem({ gallery: gallery, targetMediaId: targetMediaId, activeMedia: activeMedia });
  });

  // Auto-expand: collect contents and create <details> elements
  Array.from(document.querySelectorAll('[data-expander]')).forEach(function (expander) {
    var createdDetails = [];
    var headings = Array.from(expander.querySelectorAll(':scope > h2'));
    if (headings.length < 2) { return; }
    Array.from(expander.querySelectorAll(':scope > h2')).forEach(function (heading, i) {
      var details = document.createElement('details');
      // details.setAttribute('name', 'description');
      details.setAttribute('class', 'v2-expander-group__item');
      var summary = document.createElement('summary');
      var container = document.createElement('div');
      var inner = document.createElement('div');
      nextSibling = heading.nextElementSibling;
      while (nextSibling) {
        if (nextSibling.matches('h2')) {
          nextSibling = null;
          break;
        } else {
          var currSibling = nextSibling;
          nextSibling = currSibling.nextElementSibling;
          inner.appendChild(currSibling);
        }
      }
      if (i === 0) {
        details.setAttribute('open', '');
      }
      details.appendChild(summary);
      details.appendChild(container);
      container.appendChild(inner);
      summary.appendChild(heading);
      createdDetails.push(details);
      container.classList.add('v2-expander-group__content');
      inner.classList.add('v2-expander-group__content-inner');
      details.addEventListener('toggle', function (e) {
        let event = new CustomEvent('muse:details-toggle', {
          bubbles: true,
          detail: {
            target: e.target,
            oldState: e.oldState,
            newState: e.newState,
          }
        });
        details.dispatchEvent(event);
      });
      // Ensure the expand/collapse icon follows the size of the h2 with the same class applied to both
      [summary, heading].forEach(function(el) { el.classList.add('h4'); });
    });
    createdDetails.forEach(function(d) { expander.appendChild(d); });
    expander.setAttribute('data-expander', 'true');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-toggle-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // --- Scroll-to-compare arrow logic ---
  const arrows = document.querySelectorAll(".arrow-bottom");
  const target = document.getElementById("scrollTocompare");
  if (target && arrows.length) {
    arrows.forEach(arrow => {
      arrow.addEventListener("click", function () {
        const yOffset = -100;
        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
  }

  const showcaseContainer = document.querySelector('.shop-showcase');
  if (!showcaseContainer) return;

  // --- Dropdown popover helper (Global) ---
  document.addEventListener('click', (e) => {
    const targetButton = e.target.closest('.shop-showcase-dropdown-trigger');
    const targetWrapper = e.target.closest('.shop-showcase-dropdown-wrapper');
    document.querySelectorAll('.shop-showcase-dropdown-trigger').forEach(button => {
      if (button === targetButton) {
        button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') !== 'true');
      } else if (!targetWrapper) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  });

  const productArticles = showcaseContainer.querySelectorAll('.shop-showcase-product');

    function updateDefaultSelection(productArticle, variantType) {
    // Uncheck all radios first
    const allInputs = productArticle.querySelectorAll('.color-options input[type="radio"]');
    allInputs.forEach(input => (input.checked = false));

    // Then check the first input for the selected type
    const firstMatchingInput = productArticle.querySelector(
      `.color-options input[name^="color-"][name$="-${variantType}"]`
    );

    if (firstMatchingInput) {
      firstMatchingInput.checked = true;
    }
  }

  // Update Add to Cart button ID dynamically
  function updateAddToCartButton(productArticle, variantType) {
    const selectedInput = productArticle.querySelector(
      `.color-options input[name^="color-"][name$="-${variantType}"]:checked`
    );
    const addToCartButton = productArticle.querySelector(
      `[data-add-to-cart][data-showcase-variant="${variantType}"]`
    );

    if (selectedInput && addToCartButton) {
      const variantId = selectedInput.value;
      addToCartButton.setAttribute('data-product_id', variantId);
    }
  }

  // const updateUIForProduct = (productArticle) => {
  //   const descBlocks = productArticle.querySelectorAll('.shop-showcase-product-description');
  //   const mainImageEl = productArticle.querySelector('.shop-showcase-product-image');

  //   if (!descBlocks.length) return;

  //   // find the active description block (bundle or solo)
  //   let activeDesc = null;

  //   descBlocks.forEach(desc => {
  //     if (desc.style.display !== 'none') {
  //       activeDesc = desc;
  //     }
  //   });

  //   // fallback: use first one if none is hidden/visible controlled
  //   if (!activeDesc) activeDesc = descBlocks[0];

  //   const variantType = activeDesc.dataset.showcaseVariant; // "bundle" or "solo"
    
  //   const selectedRadio =
  //     activeDesc.querySelector('.color-option input:checked') ||
  //     activeDesc.querySelector('.color-option input');

  //   if (!selectedRadio) return;

  //   const selectedVariantId = selectedRadio.value;
  //   const addToCartBtn = activeDesc.querySelector('[data-add-to-cart]');

  //   // ✅ Update Add-to-Cart
  //   if (addToCartBtn) {
  //     addToCartBtn.dataset.product_id = selectedVariantId;
  //   }

  //   // ✅ Update image logic
  //   if (mainImageEl) {
  //     const selectedColor = selectedRadio.closest('.color-option').dataset.color;
  //     const originalImageUrl = mainImageEl.dataset.originalSrc;

  //     if (variantType === 'bundle') {
  //       // bundle rules
  //       if (selectedColor === 'opal') {
  //         mainImageEl.src = 'https://cdn.shopify.com/s/files/1/0348/7053/files/MSAthena-Hero-Opal-Img.png?v=1757631835';
  //       } else {
  //         mainImageEl.src = originalImageUrl;
  //       }

  //     } else if (variantType === 'solo') {
  //       // solo rules
  //       if (selectedColor === 'opal') {
  //         mainImageEl.src = 'https://cdn.shopify.com/s/files/1/0348/7053/files/MSAthena-Hero-Opal-Img.png?v=1757631835';
  //       } else {
  //         mainImageEl.src = originalImageUrl;
  //       }
  //     }
  //   }
  // };
const updateUIForProduct = (productArticle) => {
  const descBlocks = productArticle.querySelectorAll('.shop-showcase-product-description');
  const mainImageEl = productArticle.querySelector('.shop-showcase-product-image');

  if (!descBlocks.length || !mainImageEl) return;

  // Save original image once
  if (!mainImageEl.dataset.originalSrc) {
    mainImageEl.dataset.originalSrc = mainImageEl.src;
  }

  // Find the visible description block
  const activeDesc = Array.from(descBlocks).find(
    (desc) => desc.style.display !== 'none'
  ) || descBlocks[0];

  const selectedRadio =
    activeDesc.querySelector('.color-option input:checked') ||
    activeDesc.querySelector('.color-option input');

  if (!selectedRadio) return;

  // Update Add-to-Cart button
  const addToCartBtn = activeDesc.querySelector('[data-add-to-cart]');
  if (addToCartBtn) addToCartBtn.dataset.product_id = selectedRadio.value;

  // Update main image: only opal gets custom image
  const selectedColor = selectedRadio.closest('.color-option')?.dataset.color;

  mainImageEl.src =
    selectedColor === 'opal'
      ? 'https://cdn.shopify.com/s/files/1/0348/7053/files/MSAthena-Hero-Opal-Img.png?v=1757631835'
      : mainImageEl.dataset.originalSrc;
};

  // Get all dropdown headers (not just one by ID)
  const dropdownHeaders = document.querySelectorAll('.dropdown-header');
  
  dropdownHeaders.forEach(function(dropdownHeader) {
    let isOpen = false;
    
    dropdownHeader.addEventListener('click', function() {
      isOpen = !isOpen;
      
      // Find elements within this specific dropdown
      const dropdownContent = dropdownHeader.nextElementSibling;
      const chevronIcon = dropdownHeader.querySelector('.chevron-icon');
      
      // Find the closest parent container that holds both dropdown and buttons
      const parentContainer = dropdownHeader.closest('.shop-showcase-product-description');
      
      if (isOpen) {
        dropdownContent.classList.add('open');
        chevronIcon.classList.add('rotated');
        
        // Hide only the buttons within this specific product container
        const productButtons = parentContainer.querySelectorAll('.shop-showcase-product-buttons');
        const productUsp = parentContainer.querySelectorAll('.shop-showcase-product-usp');
        
       /* productButtons.forEach(function(button) {
          button.style.display = 'none';
        });*/
        productUsp.forEach(function(usp) {
          usp.style.display = 'none';
        });
      } else {
        dropdownContent.classList.remove('open');
        chevronIcon.classList.remove('rotated');
        
        // Show only the buttons within this specific product container
        const productButtons = parentContainer.querySelectorAll('.shop-showcase-product-buttons');
        const productUsp = parentContainer.querySelectorAll('.shop-showcase-product-usp');
      

        // productButtons.forEach(function(button) {
        //   button.style.display = 'flex';
        // });
        productUsp.forEach(function(usp) {
          usp.style.display = 'block';
        });
      }
    });
  });
    // Get all switch buttons

  const switchToSoloButtons = document.querySelectorAll('.switch-to-solo');
  const switchToBundleButtons = document.querySelectorAll('.switch-to-bundle');

  // ---- SWITCH TO SOLO ----
  // switchToSoloButtons.forEach(function(button) {
  //   button.addEventListener('click', function(e) {
  //     e.preventDefault();

  //     const productArticle = button.closest('.shop-showcase-product');
  //     const showcaseContainer = button.closest('.shop-showcase');
  //     const descriptionContainers = productArticle.querySelectorAll('.shop-showcase-product-description');

  //     descriptionContainers.forEach(desc => {
  //       desc.setAttribute('data-showcase-variant', 'solo');
  //     });

  //     if (showcaseContainer) {
  //       showcaseContainer.setAttribute('data-showcase-selected', 'solo');
  //     }

  //     updateDefaultSelection(productArticle, 'solo');
  //     updateAddToCartButton(productArticle, 'solo');
  //     updateUIForProduct(productArticle);
  //   });
  // });

  // // ---- SWITCH TO BUNDLE ----
  // switchToBundleButtons.forEach(function(button) {
  //   button.addEventListener('click', function(e) {
  //     e.preventDefault();

  //     const productArticle = button.closest('.shop-showcase-product');
  //     const showcaseContainer = button.closest('.shop-showcase');
  //     const descriptionContainers = productArticle.querySelectorAll('.shop-showcase-product-description');

  //     descriptionContainers.forEach(desc => {
  //       desc.setAttribute('data-showcase-variant', 'bundle');
  //     });

  //     if (showcaseContainer) {
  //       showcaseContainer.setAttribute('data-showcase-selected', 'bundle');
  //     }

  //     updateDefaultSelection(productArticle, 'bundle');
  //     updateAddToCartButton(productArticle, 'bundle');
  //      updateUIForProduct(productArticle);
  //   });
  // });
switchToSoloButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    const productArticle = button.closest(".shop-showcase-product");

    if (productArticle) {
      productArticle.setAttribute("data-showcase-selected", "solo");
    }

    updateDefaultSelection(productArticle, "solo");
    updateAddToCartButton(productArticle, "solo");
    updateUIForProduct(productArticle);
  });
});

switchToBundleButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    const productArticle = button.closest(".shop-showcase-product");

    if (productArticle) {
      productArticle.setAttribute("data-showcase-selected", "bundle");
    }

    updateDefaultSelection(productArticle, "bundle");
    updateAddToCartButton(productArticle, "bundle");
    updateUIForProduct(productArticle);
  });
});
  // ---- COLOR SELECTION ----
  document.querySelectorAll('.color-options input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
      const productArticle = input.closest('.shop-showcase-product');
      const variantType = input.closest('label').getAttribute('data-showcase-variant');
      updateAddToCartButton(productArticle, variantType);
    });
  });

  // ---- HELPERS ----


  // --- Initialize and add listeners for each product ---
  productArticles.forEach(productArticle => {
    const mainImageEl = productArticle.querySelector('.shop-showcase-product-image' );

    // **CRITICAL: Store the original image URL on page load**
    if (mainImageEl) {
      mainImageEl.dataset.originalSrc = mainImageEl.src;
    }
    
    // 1. Listen for color swatch changes.
    productArticle.querySelectorAll('.color-option input[type="radio"]').forEach(input => {
      input.addEventListener('change', () => updateUIForProduct(productArticle));
    });

    // 2. Set the initial state for the product on page load.
    updateUIForProduct(productArticle);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-hero-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  Array.from(document.querySelectorAll('.v1-super-hero')).forEach(function (hero) {
    var wrap = hero.querySelector('.v1-super-hero__bottom-wrap');
    var section = hero.querySelector('.v1-super-hero__bottom');
    if (!wrap || !section) { return; }
    var slides = Array.from(section.querySelectorAll('[data-slide-index]'));
    if (slides.length < 2) { return; } // No scroll = no point!
    
    var indicatorsWrap = document.createElement('ol');
    indicatorsWrap.className = 'v1-super-hero__bottom-indicators';
    slides.forEach(function (slide, index) {
      var indicatorItem = document.createElement('li');
      indicatorItem.className = 'v1-super-hero__bottom-indicator-item';

      var indicatorButton = document.createElement('button');
      indicatorButton.type = 'button';
      indicatorButton.className = 'button--reset v1-super-hero__bottom-indicator-button';
      indicatorButton.setAttribute('data-slide-target', slide.getAttribute('data-slide-index'));
      indicatorButton.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      indicatorButton.innerHTML = '<span class="visually-hidden">Go to slide #'+slide.getAttribute('data-slide-index')+'</span>';

      indicatorItem.appendChild(indicatorButton);
      indicatorsWrap.appendChild(indicatorItem);
    });

    // Once we have our indicators, update the section to hide the scrollbar
    wrap.appendChild(indicatorsWrap)
    section.setAttribute('data-has-indicators', 'true');

    var scrollDebounce;
    section.addEventListener('scroll', function (e) {
      var scroller = e.target.closest('.v1-super-hero__bottom') || section;
      var container = scroller.closest('.v1-super-hero__bottom-container');
      
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        var scrollerHeight = scroller.clientHeight;
        var scrollerScroll = scroller.scrollTop;
        var scrollProgress = Math.round(scrollerScroll / scrollerHeight);

        setActiveIndicator(container, scrollProgress + 1); // Indices are 1-indexed
      }, 30);
    });

    section.addEventListener('muse:swipe', function (e) {
      var scroller = e.target.closest('.v1-super-hero__bottom') || section;
      var container = scroller.closest('.v1-super-hero__bottom-container');
      var indicators = container.querySelector('.v1-super-hero__bottom-indicators');
      var activeButton = indicators.querySelector('[data-slide-target][aria-pressed="true"]');
      var activeItem = activeButton.closest('.v1-super-hero__bottom-indicator-item');
      var prevItem = activeItem.previousElementSibling;
      var nextItem = activeItem.nextElementSibling;
      var targetItem = e.detail.swipeDirection.x === 'left' ? nextItem : prevItem;
      if (!targetItem) { return; } // At the end of the list, no more items!
      targetItem.querySelector('[data-slide-target]').click();
    });
  });

  function setActiveIndicator(container, index) {
    index = String(index || 0).trim();

    var button = container.querySelector('[data-slide-target="'+index+'"]');
    Array.from(container.querySelectorAll('[data-slide-target]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.v1-super-hero__bottom-indicator-button[data-slide-target]');
    if (!button) { return; }
    
    var container = button.closest('.v1-super-hero__bottom-container')
    var scroller = container.querySelector('.v1-super-hero__bottom');
    var slide = scroller.querySelector('[data-slide-index="'+button.getAttribute('data-slide-target')+'"]');
    var doAnimation = Boolean(window.matchMedia('(prefers-reduced-motion: reduce)').matches) === false;
    
    slide.scrollIntoView({ behavior: doAnimation ? 'smooth' : 'instant', block: 'center' });
    setActiveIndicator(container, button.getAttribute('data-slide-target'));
  });

  // const thumbnailImages = document.querySelectorAll('.video-fullscreen-wrapper-thumbnail')
  // thumbnailImages.forEach(elem => {
  //   elem.addEventListener('click', () => {
  //     const videoId = elem.getAttribute('data-video-id')
  //     const modal = document.querySelector('.video-player-background')
  //     const modalContent = modal.querySelector('.player')
  //     if (window.customVideo.current != videoId) modalContent.innerHTML = window.customVideo[videoId]
  //     modal.style.display = 'block'
  //     if (modalContent.querySelector('video')) modalContent.querySelector('video').play()
  //     window.customVideo.current = videoId
  //   })
  // })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-slider-v1"] && !Shopify.designMode) return;
  try {
    
  function setTabSlideIndex(slider, slideIndex = 1) {
    var slideMax = parseInt(slider.getAttribute('data-slide-max'), 10);
    var slideTrigger = slider.querySelector('[data-tabslide-trigger="'+String(slideIndex)+'"]');
    var slideItem = slider.querySelector('[data-tabslide-index="'+String(slideIndex)+'"]');

    if (slideIndex < 1) { slideIndex = 1; }
    if (slideIndex > slideMax) { slideIndex = slideMax; }

    for (var i = 1 ; i <= slideMax ; i++) {
      var loopTrigger = slider.querySelector('[data-tabslide-trigger="'+String(i)+'"]');
      var loopItem = slider.querySelector('[data-tabslide-index="'+String(i)+'"]');
      var isCurrent = i === slideIndex

      loopTrigger.setAttribute('aria-pressed', isCurrent.toString());
      loopItem.setAttribute('data-tabslide-active', isCurrent.toString());
    }

    slider.setAttribute('data-slide-current', slideIndex);
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    Array.from(document.querySelectorAll('.v1-tab-slider')).forEach(function(s) {
      s.setAttribute('data-is-interactive', 'true');
      setTabSlideIndex(s, 1);
    });
  });

  document.addEventListener('click', function(e) {
    var slideTrigger = e.target.closest('[data-tabslide-trigger]');
    if (!slideTrigger) { return; }
    var slider = slideTrigger.closest('.v1-tab-slider');
    var triggerTargetIndex = parseInt(slideTrigger.getAttribute('data-tabslide-trigger'), 10);

    setTabSlideIndex(slider, triggerTargetIndex);
  });
  
  document.addEventListener('muse:swipe', function (e) {
    var targetSlider = e.target.closest('.v1-tab-slider');
    if (!targetSlider) { return; }
    var currentButton = targetSlider.querySelector('[data-tabslide-trigger][aria-pressed="true"]');
    var swipeDirection = e.detail.swipeDirection.x;
    var newTarget;
    
    if (swipeDirection === 'left') {
      newTarget = currentButton.closest('.v1-tab-slider__tab').nextElementSibling;
    } else if (swipeDirection === 'right') {
      newTarget = currentButton.closest('.v1-tab-slider__tab').previousElementSibling;
    }

    if (!newTarget) { return; }
    newTarget.querySelector('[data-tabslide-trigger]').click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-slider-v2"] && !Shopify.designMode) return;
  try {
    
  function setTabSlideIndex(slider, slideIndex = 1) {
    var slideMax = parseInt(slider.getAttribute('data-slide-max'), 10);
    var slideTrigger = slider.querySelector('[data-tabslide-trigger="'+String(slideIndex)+'"]');
    var slideItem = slider.querySelector('[data-tabslide-index="'+String(slideIndex)+'"]');

    if (slideIndex < 1) { slideIndex = 1; }
    if (slideIndex > slideMax) { slideIndex = slideMax; }

    for (var i = 1 ; i <= slideMax ; i++) {
      var loopTrigger = slider.querySelector('[data-tabslide-trigger="'+String(i)+'"]');
      var loopItem = slider.querySelector('[data-tabslide-index="'+String(i)+'"]');
      var isCurrent = i === slideIndex

      loopTrigger.setAttribute('aria-pressed', isCurrent.toString());
      loopItem.setAttribute('data-tabslide-active', isCurrent.toString());
    }

    slider.setAttribute('data-slide-current', slideIndex);
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    Array.from(document.querySelectorAll('.v2-tab-slider.tab-v2')).forEach(function(s) {
      s.setAttribute('data-is-interactive', 'true');
      setTabSlideIndex(s, 1);
    });
  });

  document.addEventListener('click', function(e) {
    var slideTrigger = e.target.closest('[data-tabslide-trigger]');
    if (!slideTrigger) { return; }
    var slider = slideTrigger.closest('.v2-tab-slider.tab-v2');
    var triggerTargetIndex = parseInt(slideTrigger.getAttribute('data-tabslide-trigger'), 10);

    setTabSlideIndex(slider, triggerTargetIndex);
  });
  
  document.addEventListener('muse:swipe', function (e) {
    var targetSlider = e.target.closest('.v2-tab-slider.tab-v2');
    if (!targetSlider) { return; }
    var currentButton = targetSlider.querySelector('[data-tabslide-trigger][aria-pressed="true"]');
    var swipeDirection = e.detail.swipeDirection.x;
    var newTarget;
    
    if (swipeDirection === 'left') {
      newTarget = currentButton.closest('.v2-tab-slider__tab').nextElementSibling;
    } else if (swipeDirection === 'right') {
      newTarget = currentButton.closest('.v2-tab-slider__tab').previousElementSibling;
    }

    if (!newTarget) { return; }
    newTarget.querySelector('[data-tabslide-trigger]').click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('muse:play', function(e) {
  console.log(e);
  var testimonialVideo = e.target.closest('video');
  var testimonialCarousel = testimonialVideo.closest('.v1-testimonial-carousel');
  Array.from(testimonialCarousel.querySelectorAll('video')).forEach(function(v) {
    console.log(v, testimonialVideo)
    // Pause other videos
    if (v !== testimonialVideo) {
      v.pause();
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  Array.from(document.querySelectorAll('video.v1-testimonial-carousel__social-background')).forEach(function (video) {
    video.addEventListener('play', function (v) {
      let event = new CustomEvent('muse:play', {
        bubbles: true,
        detail: { play: true , target: v },
      });
      video.dispatchEvent(event);
    })
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel-v2"] && !Shopify.designMode) return;
  try {
    
// document.addEventListener('muse:play', function(e) {
//   var testimonialVideo = e.target.closest('video');
//   var testimonialCarousel = testimonialVideo.closest('.v2-testimonial-carousel');
//   var videoBtn = testimonialVideo.closest('.v2-testimonial-carousel__card-inner').querySelector('.video-btn');

//   // Pause other videos
//   Array.from(testimonialCarousel.querySelectorAll('video')).forEach(function(v) {
//     if (v !== testimonialVideo) {
//       v.pause();
//     }
//   });

//   // Hide play icon and show video controls
//   videoBtn.style.display = 'none'; // Hide the play button when the video starts
// });

// document.addEventListener('DOMContentLoaded', function() {
//   Array.from(document.querySelectorAll('video.v2-testimonial-carousel__social-background')).forEach(function (video) {
//     // Listen for the play event to dispatch custom event and hide play button
//     video.addEventListener('play', function () {
//       let event = new CustomEvent('muse:play', {
//         bubbles: true,
//         detail: { play: true , target: video },
//       });
//       video.dispatchEvent(event);
//     });

//     // Listen for pause event to show play button
//     video.addEventListener('pause', function () {
//       var videoBtn = video.closest('.v2-testimonial-carousel__card-inner').querySelector('.video-btn');
//       videoBtn.style.display = 'grid'; // Show play button when video is paused
//     });
//   });

//   // Add click event on video button to play video
//   Array.from(document.querySelectorAll('.video-btn')).forEach(function (btn) {
//     btn.addEventListener('click', function() {
//       var video = btn.closest('.v2-testimonial-carousel__card-inner').querySelector('video');
      
//       if (video.paused) {
//         video.play();  // Play the video
//         // Hide the play button when clicked
//         btn.style.display = 'none';

//         // Dispatch custom event to handle play actions
//         let event = new CustomEvent('muse:play', {
//           bubbles: true,
//           detail: { play: true , target: video },
//         });
//         video.dispatchEvent(event);
//       }
//     });
//   });
// });



document.addEventListener('muse:play', function(e) {
  console.log(e);
  var testimonialVideo = e.target.closest('video');
  var testimonialCarousel = testimonialVideo.closest('.v2-testimonial-carousel');
  Array.from(testimonialCarousel.querySelectorAll('video')).forEach(function(v) {
    console.log(v, testimonialVideo)
    // Pause other videos
    if (v !== testimonialVideo) {
      v.pause();
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
  Array.from(document.querySelectorAll('video.v2-testimonial-carousel__social-background')).forEach(function (video) {
    video.addEventListener('play', function (v) {
      let event = new CustomEvent('muse:play', {
        bubbles: true,
        detail: { play: true , target: v },
      });
      video.dispatchEvent(event);
    })
  });
});

  } catch(e) { console.error(e); }
})();
})();
